<template>
    <v-container fluid fill-height grid-list-xs pa-0 :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-layout row wrap> <!--fluid fill-height row justify-center>-->
            <v-flex d-flex xs12 pa-0>
                <v-card class="fill-height flex-card">
                    <!-- <v-breadcrumbs :items="breadCrumbs" class="dense">
                        <template v-slot:divider>
                            <v-icon>forward</v-icon>
                        </template>
                    </v-breadcrumbs> -->
                    <!--
                    <v-card-title><h2>{{ $t("optimization") }}</h2></v-card-title>
                    -->
                    <v-toolbar scrollable card prominent dense>
                        <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    class="px-1"
                                    v-on="on"
                                    @click="showSelectCutsDialog"
                                >
                                    <v-icon>mdi-view-sequential</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("selectCuts") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("selectCuts") }}</span>
                        </v-tooltip>

                        <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    class="px-1"
                                    v-on="on"
                                    :disabled="!acl.Create || !calcEnabled"
                                    @click="calculate"
                                >
                                    <v-icon>mdi-calculator</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("calculate") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("calculate") }}</span>
                        </v-tooltip>

                        <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    class="px-1"
                                    v-on="on"
                                    @click="showEditPatternDlg()"
                                    :disabled="!acl.Create || Object.keys(pattern).length === 0"
                                >
                                    <v-icon>mdi-pencil-outline</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("edit") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("edit") }}</span>
                        </v-tooltip>

                        <v-menu bottom offset-y>
                            <template #activator="{ on: menu }">
                                <v-tooltip
                                    bottom
                                    :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >
                                    <template #activator="{ on: tooltip }">
                                        <v-btn
                                            flat
                                            class="pa-0"
                                            v-on="{ ...tooltip, ...menu }"
                                            :disabled="!saveActive || !aclPatterns.Create"
                                        >
                                            <v-icon>mdi-content-save-outline</v-icon>
                                            <span
                                                v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                            >{{ $t("save") }}</span>
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("save") }}</span>
                                </v-tooltip>
                            </template>
                            <v-list>
                                <v-list-tile
                                    @click="savePatternClick"
                                >
                                    <v-list-tile-title><v-icon>mdi-latitude</v-icon> {{ $t("pattern").toUpperCase() }}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                    @click="saveCalculationClick"
                                    :disabled="$store.getters.subscription.settings.contracts && $store.getters.subscription.settings.contracts.lock"
                                >
                                    <v-list-tile-title><v-icon>mdi-calculator-variant-outline</v-icon> {{ $t("calculation").toUpperCase() }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-menu bottom offset-y>
                            <template #activator="{ on: menu }">
                                <v-tooltip
                                    bottom
                                    :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >
                                    <template v-slot:activator="{ tooltip }">
                                        <v-btn
                                            flat
                                            class="pa-0"
                                            v-on="{ ...tooltip, ...menu }"
                                            :disabled="!saveActive || !acl.Export || $store.getters.subscription.settings.optimization.denyExport"
                                        >
                                            <v-icon>mdi-download-outline</v-icon>
                                            <span
                                                v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                            >{{ $t("download") }}</span>
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("download") }}</span>
                                </v-tooltip>
                            </template>
                            <v-list>
                                <v-list-tile
                                    v-for="(item, index) in downloadType"
                                    :key="index"
                                    @click="downloadPatternClick(item.value)"
                                >
                                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <!-- Кнопка печать-->
                        <v-menu bottom offset-y>
                            <template #activator="{ on: menu }">
                                <v-tooltip
                                    bottom
                                    :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >
                                    <template #activator="{ on: tooltip }">
                                        <v-btn
                                        flat
                                        class="pa-0"
                                        v-on="{ ...tooltip, ...menu }"
                                        :disabled="!saveActive || !acl.Export"
                                        >
                                            <v-icon>mdi-printer-outline</v-icon>
                                            <span
                                                v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                            >{{ $t("print") }}</span>
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("print") }}</span>
                                </v-tooltip>
                            </template>
                            <v-list>
                                <v-list-tile
                                    v-for="(item, index) in printType"
                                    :key="index"
                                    @click="printPatternClick(item.value)"
                                >
                                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <!-- Кнопка 3Д -->
                        <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    class="pa-0"
                                    v-on="on"
                                    @click="show3DViewClick"
                                    :disabled="!pattern3DEnable"
                                >
                                    <v-icon>mdi-rotate-3d</v-icon>
                                </v-btn>
                            </template>
                            <span> 3D </span>
                        </v-tooltip>
                        <!-- Меню с историей и сохраненными расчетами -->
                        <v-menu bottom offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    class="pa-0"
                                    v-on="on"
                                >
                                    <v-icon>mdi-history</v-icon>
                                    <!-- <v-icon>mdi-dots-vertical</v-icon> -->
                                    <v-icon>mdi-chevron-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile
                                    @click="tasksHistoryClick"
                                >
                                    <v-list-tile-title> <v-icon>mdi-history</v-icon> <span class="ml-1 subheading mb-5">{{ $t("history").toUpperCase() }}</span> </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                    :disabled="$store.getters.subscription.settings.contracts && $store.getters.subscription.settings.contracts.lock"
                                    @click="savedCalculationsClick"
                                >
                                    <v-list-tile-title> <v-icon>mdi-calculator-variant-outline</v-icon> <span class="ml-1 subheading mb-5">{{ $t("savedСalculations").toUpperCase() }}</span> </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <!-- <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="tasksHistoryClick"
                                >
                                    <v-icon>mdi-history</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("history") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("history") }}</span>
                        </v-tooltip> -->

                    </v-toolbar>

                    <v-card-text class="fill-height pa-0">
                        <v-container fluid fill-height grid-list-xs pa-0>
                            <v-layout row wrap>
                                <v-flex xs12 md3 lg3 d-flex pa-0>
                                    <v-sheet
                                        class="grey v-scrollable"
                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                    >
                                        <v-expansion-panel v-model="leftPanel" readonly expand class="elevation-0" style="overflow-y: hidden;">
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row align-center>
                                                            <v-flex xs10>
                                                                <v-select
                                                                    v-model="equipmentId"
                                                                    :items="equipmentProfiles"
                                                                    item-text="name"
                                                                    item-value="id"
                                                                    :label="$t('equipmentProfile')"
                                                                ></v-select>
                                                            </v-flex>
                                                            <v-flex xs2>
                                                                <v-btn icon flat small @click="$router.replace({ path: '/equipment' })">
                                                                    <v-icon>mdi-cogs</v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <v-select
                                                                    v-model="optMethod"
                                                                    :items="methods"
                                                                    item-text="name"
                                                                    item-value="code"
                                                                    :label="$t('optimizationMethod')"
                                                                    hide-details
                                                                    dense
                                                                ></v-select>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <!-- Порода -->
                                            <v-expansion-panel-content

                                                hide-actions
                                                class="grey mt-3"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs10 d-flex>
                                                                <v-select
                                                                    v-model="speciesId"
                                                                    :items="speciesFiltered"
                                                                    item-text="name"
                                                                    item-value="id"
                                                                    :label="$t('speciesAlt')"
                                                                    hide-details
                                                                    dense
                                                                    v-if="speciesFiltered.length > 0"
                                                                ></v-select>
                                                                <v-alert
                                                                    type="warning"
                                                                    value="true"
                                                                    v-if="speciesLoaded && speciesFiltered.length == 0"
                                                                >{{ $t("noSpeciesSelectedWarning") }}</v-alert>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>

                                            <!-- Размеры бревна -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <!-- <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("logDimensions") }}</div>
                                                </template> -->
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    style="overflow-x: auto; overflow-y: hidden;"
                                                >

                                                    <v-card-text v-if="false" class="dense text-xs-right">{{ $t("volume") }}, {{ $t("m3") }}: <b>{{ volume }}</b></v-card-text>
                                                    <v-card-text class="dense">
                                                        <div class="subheading font-weight-black pl-2 pt-2 mt-2">{{ $t("logDimensions") }}</div>
                                                        <v-layout row align-center mb-1 v-if="useUserVolumeInput">
                                                            <v-flex xs6>
                                                               {{$t('logVolume')}}, {{ $t("m")}}<sup>3</sup>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <v-text-field
                                                                    :value="volume"
                                                                    @change="volume = $event"
                                                                    class="mt-0 pt-0 pr-2"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero]"
                                                                    flat
                                                                    dense
                                                                    hide-details
                                                                ></v-text-field>
                                                            </v-flex>

                                                        </v-layout>

                                                        <v-layout row>
                                                            <v-flex xs9>
                                                                <span class="pl-0">{{ $t("diameterTop") }}, {{ $t("mm") }}</span>
                                                                <v-slider
                                                                    v-model="dTop"
                                                                    :min="50"
                                                                    :max="999"
                                                                    class="pr-2 mt-0"
                                                                    hide-details
                                                                    dense
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs3 mt-2>
                                                                <v-text-field
                                                                    :value="dTop"
                                                                    @change="dTop = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.dTop]"
                                                                    dense
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row>
                                                            <v-flex xs9>
                                                                <span class="pl-0">{{ $t("length") }}, {{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="length"
                                                                    :min="1.0"
                                                                    :max="10.0"
                                                                    :step="0.1"
                                                                    class="pr-2 mt-0"
                                                                    hide-details
                                                                    dense
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs3 mt-2>
                                                                <v-text-field
                                                                    :value="length"
                                                                    @change="length = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.length]"
                                                                    dense
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <!--
                                                        <v-layout row>
                                                            <v-flex xs9>
                                                                <span class="pl-0">{{ $t("falseCore") }}, %</span>
                                                                <v-slider
                                                                    v-model="falseCore"
                                                                    :min="0"
                                                                    :max="50"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs3 mt-2>
                                                                <v-text-field
                                                                    v-model="falseCore"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.falseCore]"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        -->

                                                        <v-layout row v-if="!useUserVolumeInput && !useStdTable">
                                                            <v-flex xs9>
                                                                <span class="pl-0">{{ $t("taper") }}, {{ $t("mm")}}/{{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="taper"
                                                                    :min="0"
                                                                    :max="30"
                                                                    :step="0.1"
                                                                    :disabled="useStdTable"
                                                                    class="pr-2 mt-0"
                                                                    hide-details
                                                                    dense
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs3 mt-2>
                                                                <v-text-field
                                                                    :value="taper"
                                                                    @change="taper = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero, rules.taper]"
                                                                    :disabled="useStdTable"
                                                                    dense
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="my-1"></v-divider>
                                                        <v-layout row>
                                                            <v-flex xs9>
                                                                <span class="pl-0">{{ $t("curvature") }}, %</span>
                                                                <v-slider
                                                                    v-model="curvature"
                                                                    :min="0"
                                                                    :max="2"
                                                                    :step="0.05"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                    dense
                                                                    hide-details
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs3 mt-2>
                                                                <v-text-field
                                                                    :value="curvature"
                                                                    @change="curvature = $event"
                                                                    class="mt-0 mr-0"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero, rules.curvature]"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                    dense
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <span class="pl-0">{{ $t("curvatureCenter") }}</span>
                                                                <v-slider
                                                                    v-model="curvatureCenter"
                                                                    :min="0.05"
                                                                    :max="0.95"
                                                                    :step="0.05"
                                                                    ticks
                                                                    :tick-labels="curvatureSliderLabels"
                                                                    always-dirty
                                                                    :thumb-size="30"
                                                                    :thumb-label="true"
                                                                    class="mt-0 pr-0 pt-0"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                    dense
                                                                ></v-slider>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="my-1"></v-divider>
                                                        <v-layout column>
                                                            <v-flex xs12 mt-2>
                                                                <span class="pl-0">{{ $t("ellipseRatio") }}, %</span>
                                                            </v-flex>
                                                            <v-flex xs12>
                                                                <v-layout>
                                                                    <v-flex xs8>
                                                                        <v-slider
                                                                            v-model="ellipseRatio"
                                                                            :min="0"
                                                                            :max="10"
                                                                            :step="0.1"
                                                                            class="pr-2 mt-0"
                                                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                            hide-details
                                                                            dense
                                                                        ></v-slider>
                                                                    </v-flex>
                                                                    <v-flex xs3>
                                                                        <v-text-field
                                                                            :value="ellipseRatio"
                                                                            @change="ellipseRatio = $event"
                                                                            class="mt-0 pt-0 mx-1"
                                                                            type="number"
                                                                            :rules="[rules.requiredNumAllowZero, rules.ellipse]"
                                                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                            dense
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs1>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <v-checkbox
                                                                                    v-on="on"
                                                                                    :input-value="rotate == 90"
                                                                                    @change="rotate = rotate == 0 ? 90 : 0"
                                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                                    hide-details
                                                                                >
                                                                                </v-checkbox>
                                                                            </template>
                                                                            <span>{{ $t("rotateLog90deg") }}</span>
                                                                        </v-tooltip>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                        <!-- <v-layout row>
                                                            <v-flex xs12 >
                                                                <v-switch
                                                                    :ripple="false"
                                                                    :label="$t('rotateLog90deg')"
                                                                    :input-value="rotate == 90"
                                                                    @change="rotate = rotate == 0 ? 90 : 0"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                >
                                                                </v-switch>
                                                            </v-flex>
                                                        </v-layout> -->
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>

                                            <!-- Центральные доски -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <!-- <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("centralBoards") }}</div>
                                                </template> -->
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row align-center pl-2 pt-2>
                                                            <div class="subheading font-weight-black">{{ $t("centralBoards") }}</div>
                                                            <v-btn icon flat small @click="$router.replace({ path: '/lumber' })">
                                                                <v-icon>mdi-cogs</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <template>
                                                            <v-data-table
                                                                item-key="id"
                                                                :headers="boardsHeader"
                                                                :items="boardsCentral"
                                                                :rows-per-page-items="[100]"
                                                                hide-actions
                                                                class="dense-table"
                                                            >
                                                                <template v-slot:items="props">
                                                                    <td>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <span v-on="on">{{ props.item.size }}</span>
                                                                            </template>
                                                                            <span>{{ props.item.sawSize }}</span>
                                                                        </v-tooltip>
                                                                    </td>
                                                                    <td>
                                                                        <v-edit-dialog
                                                                            :return-value.sync="props.item.length"
                                                                            lazy
                                                                            @open="openEditLengthDialog(props.item)"
                                                                            @close="closeEditLengthDialog(props.item)"
                                                                        >
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on }">
                                                                                    <span v-on="on" style="min-width: 60px;">
                                                                                        {{ $num.dropZeros(parseFloat(props.item.length.substr(0, props.item.length.indexOf(",")))) }} <template v-if="props.item.length.lastIndexOf(',') > 0">..</template> {{ $num.dropZeros(parseFloat(props.item.length.substr(props.item.length.lastIndexOf(",") + 1, props.item.length.length - props.item.length.lastIndexOf(",")))) }}
                                                                                    </span>
                                                                                </template>
                                                                                <span>{{ formattedLengthsString(props.item.length) }}</span>
                                                                            </v-tooltip>
                                                                            <template v-slot:input>
                                                                                <div style="height: 200px; max-width: 280px;">
                                                                                    <p class="body-1 center mt-1 mb-2 pa-0"> {{ $t("temporaryLengthChange") }} </p>
                                                                                    <v-select
                                                                                        v-model="selectedLengths"
                                                                                        :items="lengths"
                                                                                        attach
                                                                                        chips
                                                                                        clearable
                                                                                        dense
                                                                                        return-object
                                                                                        item-text="length"
                                                                                        item-value="id"
                                                                                        :menu-props="lengthsMenuProps"
                                                                                        :label="$t('lengths')"
                                                                                        multiple

                                                                                    ></v-select>
                                                                                </div>
                                                                            </template>
                                                                        </v-edit-dialog>
                                                                    </td>
                                                                    <td class="text-xs-right">{{ props.item.price }}</td>
                                                                    <td class="text-xs-right">{{ props.item.expenses }}</td>
                                                                </template>
                                                            </v-data-table>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <!-- Боковые доски -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <!-- <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("sideBoards") }}</div>
                                                </template> -->
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row align-center pl-2 pt-2>
                                                            <div class="subheading font-weight-black">{{ $t("sideBoards") }}</div>
                                                            <v-btn icon flat small @click="$router.replace({ path: '/lumber' })">
                                                                <v-icon>mdi-cogs</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <template>
                                                            <v-data-table
                                                                :headers="boardsHeader"
                                                                :items="boardsSide"
                                                                :rows-per-page-items="[100]"
                                                                hide-actions
                                                                class="dense-table"
                                                            >
                                                                <template v-slot:items="props">
                                                                    <td>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <span v-on="on">{{ props.item.size }}</span>
                                                                            </template>
                                                                            <span>{{ props.item.sawSize }}</span>
                                                                        </v-tooltip>
                                                                    </td>
                                                                    <td>
                                                                        <v-edit-dialog
                                                                            :return-value.sync="props.item.length"
                                                                            lazy
                                                                            @open="openEditLengthDialog(props.item)"
                                                                            @close="closeEditLengthDialog(props.item)"
                                                                        >
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on }">
                                                                                    <span v-on="on" style="min-width: 60px;">
                                                                                        {{ $num.dropZeros(parseFloat(props.item.length.substr(0, props.item.length.indexOf(",")))) }} <template v-if="props.item.length.lastIndexOf(',') > 0">..</template> {{ $num.dropZeros(parseFloat(props.item.length.substr(props.item.length.lastIndexOf(",") + 1, props.item.length.length - props.item.length.lastIndexOf(",")))) }}
                                                                                    </span>
                                                                                </template>
                                                                                <span>{{ formattedLengthsString(props.item.length) }}</span>
                                                                            </v-tooltip>
                                                                            <template v-slot:input>
                                                                                <div style="height: 200px; max-width: 280px;">
                                                                                    <p class="body-1 center mt-1 mb-2 pa-0"> {{ $t("temporaryLengthChange") }} </p>
                                                                                    <v-select
                                                                                        v-model="selectedLengths"
                                                                                        :items="lengths"
                                                                                        attach
                                                                                        chips
                                                                                        clearable
                                                                                        dense
                                                                                        return-object
                                                                                        item-text="length"
                                                                                        item-value="id"
                                                                                        :menu-props="lengthsMenuProps"
                                                                                        :label="$t('lengths')"
                                                                                        multiple

                                                                                    ></v-select>
                                                                                </div>
                                                                            </template>
                                                                        </v-edit-dialog>
                                                                    </td>
                                                                    <td class="text-xs-right">{{ props.item.price }}</td>
                                                                    <td class="text-xs-right">{{ props.item.expenses }}</td>
                                                                </template>
                                                            </v-data-table>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <!-- Параметры пиления -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row align-center pl-2 pt-2>
                                                            <div class="subheading font-weight-black">{{ $t("sawingSettings") }}</div>
                                                            <v-btn icon flat small @click="$router.replace({ path: '/settings' })">
                                                                <v-icon>mdi-cogs</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <v-layout row justify-center align-center>
                                                            <v-flex xs10>
                                                                {{ $t("usingWane") }}
                                                            </v-flex>
                                                            <v-flex xs2>
                                                                <v-checkbox
                                                                    v-model="useWane"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockWane"
                                                                    dense
                                                                    hide-details
                                                                ></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="my-1"></v-divider>
                                                        <v-layout row justify-center align-center>
                                                            <v-flex xs10>
                                                                {{ $t("corelessBoard") }}
                                                            </v-flex>
                                                            <v-flex xs2>
                                                                <v-checkbox
                                                                    v-model="useCorelessBoard"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCoreless"
                                                                    dense
                                                                    hide-details
                                                                ></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row align-center>
                                                            <v-flex xs4>
                                                                <v-text-field
                                                                    :value="corelessBoardThickness"
                                                                    @change="corelessBoardThickness = $event"
                                                                    :label="`${$t('thickness')}, ${$t('mm')}`"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.corelessBoardThickness]"
                                                                    :disabled="!useCorelessBoard"
                                                                    dense
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs4>
                                                                <v-text-field
                                                                    :label="`${$t('priceM3')}`"
                                                                    :value="corelessBoardPrice"
                                                                    @change="corelessBoardPrice = $event"
                                                                    class="mt-0 mx-1"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero, rules.corelessBoardPrice]"
                                                                    :disabled="!useCorelessBoard"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-sheet>
                                </v-flex>
                                <v-flex xs12 md6 lg7 d-flex id="screen-full">
                                    <v-sheet class="d-flex v-scrollable">
                                        <v-card xs12 flat>
                                            <!--
                                            <v-card-title>
                                                <div class="subheading font-weight-black ">{{ $t("calculatedBoards") }}</div>
                                            </v-card-title>
                                            -->
                                            <v-card-text class="text-xs-center" id="screen-info">
                                                <v-layout row wrap>
                                                    <v-flex xs12 lg6>
                                                        <div class="pattern-container" >
                                                            <!--
                                                            <v-layout row>
                                                                <v-flex v-if="!objectIsEmpty(pattern)" xs6 text-xs-left><v-icon>mdi-cash-100</v-icon> {{ totalPrice }}</v-flex>
                                                                <v-flex v-if="!objectIsEmpty(pattern)" xs6 text-xs-right mt-1>{{ output.toFixed(2) }}%</v-flex>
                                                            </v-layout>
                                                            -->
                                                            <pattern-vue
                                                                id="screen-pattern"
                                                                :pattern="pattern"
                                                                :sizeNominal="sizeNominal"
                                                                :falseCore="falseCore"
                                                                :showCross="showAxes"
                                                                :showCutScheme="showCutScheme"
                                                                :logDTop="selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo) ? logInfo.dTop : selectedGroup[resIndex].recalcLogInfo.dTop "
                                                                :logDBottom="selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo) ? logInfo.dBottom : selectedGroup[resIndex].recalcLogInfo.dBottom"
                                                                :curvatureHeight="(selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo) ? logInfo.length : selectedGroup[resIndex].recalcLogInfo.len) *
                                                                                  (selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo) ? logInfo.curvature : selectedGroup[resIndex].recalcLogInfo.curvature) * 9.8"
                                                                :ellipseRatio="selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo) ? logInfo.ellipseRatio : selectedGroup[resIndex].recalcLogInfo.ellipseRatio"
                                                                :rotate="selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo) ? logInfo.rotationAngle : selectedGroup[resIndex].recalcLogInfo.rotationAngle"
                                                                :patternSolidBG="patternSolidBG"
                                                                :rotatePattern="rotatePattern"
                                                                sideSize="400"

                                                                ref="PatternVue"
                                                            />
                                                        </div>
                                                        <div class="pattern-legend">
                                                            <div class="line-wrapper">
                                                                <div class="line-marker">
                                                                    <hr class="solid">
                                                                </div>
                                                                {{ $t("top") }}
                                                            </div>
                                                            <!--
                                                            <div class="line-wrapper">
                                                                <div class="line-marker">
                                                                    <hr class="dotted">
                                                                </div>
                                                                {{ $t("top") }}
                                                            </div>
                                                            -->
                                                            <div class="line-wrapper">
                                                                <div class="line-marker">
                                                                    <hr class="dashed">
                                                                </div> {{ $t("maxCurvature") }}
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 lg6>
                                                        <v-card
                                                            class="ml-4 text-xs-left transparent-bg"
                                                            flat
                                                            tile
                                                            v-if="showPatternInfo"
                                                        >
                                                            <table>
                                                                <tbody class="info-table">
                                                                    <tr>
                                                                        <td>{{ $t("speciesAlt") }}:</td>
                                                                        <td><b>{{ logInfo.species !== null ? $t(logInfo.species) : "" }}</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("price") }}:</td>
                                                                        <td><b>{{
                                                                            totalPrice
                                                                            }}</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("output") }}:</td>
                                                                        <td><b>{{
                                                                            `${output.toFixed(2)}% / ${outputRaw}%`
                                                                            }}</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("expenditure") }}:</td>
                                                                        <td><b>{{
                                                                            (1 / output * 100).toFixed(2)
                                                                            }}</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("volume") }}:</td>
                                                                        <td><b>{{
                                                                            selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo)
                                                                                ? $num.dropZeros(logInfo.volume)
                                                                                : parseFloat(selectedGroup[resIndex].recalcLogInfo.volume).toFixed(3)
                                                                            }} {{ $t("m")}}<sup>3</sup></b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("top") }}:</td>
                                                                        <td><b>{{
                                                                            selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo)
                                                                                ? logInfo.dTop
                                                                                : selectedGroup[resIndex].recalcLogInfo.dTop
                                                                            }} {{ $t("mm")}}</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("bottom") }}:</td>
                                                                        <td><b>{{
                                                                            selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo)
                                                                                ? logInfo.dBottom
                                                                                : selectedGroup[resIndex].recalcLogInfo.dBottom
                                                                            }} {{ $t("mm")}}</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("length") }}:</td>
                                                                        <td><b>{{ selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo)
                                                                                ? logInfo.length.toFixed(2)
                                                                                : selectedGroup[resIndex].recalcLogInfo.len
                                                                            }}
                                                                            {{ $t("m")}}</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("curvature") }}:</td>
                                                                        <td><b>{{
                                                                            selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo)
                                                                                ? logInfo.curvature.toFixed(2)
                                                                                : selectedGroup[resIndex].recalcLogInfo.curvature }}%</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{{ $t("ellipseRatio") }}:</td>
                                                                        <td><b>{{
                                                                            selectedGroup[resIndex] == null || $obj.isEmpty(selectedGroup[resIndex].recalcLogInfo)
                                                                                ? logInfo.ellipseRatio.toFixed(2)
                                                                                : selectedGroup[resIndex].recalcLogInfo.ellipseRatio }}%</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="calcTimestamp">
                                                                        <td>{{ $t("calculated") }}:</td>
                                                                        <td><b>{{ calcTimestamp }}</b></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <div class="cutting-scheme">
                                                                <p>{{ $t("pattern") }} 1:
                                                                    <b v-if="sizeNominal == 1">{{ this.$refs.PatternVue.cuttingSchemeStr[0] }}</b>
                                                                    <b v-else>{{ this.$refs.PatternVue.cuttingSchemeStr[2] }}</b>
                                                                </p>
                                                                <p>{{ $t("pattern") }} 2:
                                                                    <b v-if="sizeNominal == 1">{{ this.$refs.PatternVue.cuttingSchemeStr[1] }}</b>
                                                                    <b v-else>{{ this.$refs.PatternVue.cuttingSchemeStr[3] }}</b>
                                                                </p>
                                                            </div>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                            <v-toolbar card prominent dense class="ignore-element">
                                                <div class="mt-1">{{ $t("showSizes") }}&nbsp; </div>
                                                <v-radio-group v-model="sizeNominal" hide-details row :disabled="$obj.isEmpty(pattern)">
                                                    <v-radio :value="1" :label="$t('nominalSizes')"></v-radio>
                                                    <v-radio :value="0" :label="$t('actualSizes')"></v-radio>
                                                </v-radio-group>

                                                <v-divider vertical class="mx-2"></v-divider>
                                                <div class="mt-1 mr-1"> {{ $t("showCutScheme") }}&nbsp; </div>
                                                <v-checkbox
                                                v-model="showCutScheme"
                                                class="mt-4"
                                                :disabled="$obj.isEmpty(pattern)"
                                                style="max-width: 25px"
                                                ></v-checkbox>

                                                <v-divider vertical class="mx-2"></v-divider>
                                                <div class="mt-1 mr-1"> {{ $t("logsAmount") }}&nbsp; </div>
                                                <v-text-field
                                                    v-model="logsAmount"
                                                    @change="calcLogInfo()"
                                                    :suffix="$t('pc')"
                                                    class="mb-2"
                                                    type="number"
                                                    :disabled="$obj.isEmpty(pattern)"
                                                    :rules="[rules.logsAmount]"
                                                    dense
                                                    hide-details
                                                    style="max-width: 60px"
                                                ></v-text-field>
                                            </v-toolbar>
                                            <v-card-text class="py-0">
                                                <template>
                                                    <v-data-table
                                                        :headers="calculatedHeader"
                                                        :items="calculatedData"
                                                        :rows-per-page-items="[100]"
                                                        hide-actions
                                                        class="dense-table"
                                                    >
                                                        <template v-slot:items="props">
                                                            <td>{{ props.item.size }}</td>
                                                            <td>{{ props.item.length }}</td>
                                                            <td>{{ props.item.qty }}</td>
                                                            <td>{{ props.item.volume }}</td>
                                                            <td>{{ props.item.percent }}</td>
                                                            <td class="text-xs-right">{{ props.item.price }}</td>
                                                        </template>
                                                    </v-data-table>
                                                </template>
                                            </v-card-text>
                                        </v-card>
                                    </v-sheet>
                                </v-flex>
                                <v-flex xs12 md3 lg2 d-flex>
                                    <v-sheet
                                        class="grey"
                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                    >
                                        <v-expansion-panel
                                            v-model="optPanel"
                                            class="v-scrollable"
                                        >
                                            <v-expansion-panel-content>
                                                <template v-slot:header>
                                                    <div>{{ $t("byVolume") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text
                                                        v-if="resByVol.length > 0"
                                                    >
                                                        <div
                                                            v-for="(item, index) in resByVol"
                                                            :key="index"
                                                            class="text-xs-center mb-2 c-pointer"
                                                            style="display: block"
                                                            @click="showInfoTable(resByVol, 'volume', index)"
                                                        >
                                                            <div class="pattern-thumb-container">
                                                                <pattern-vue
                                                                    class="thumb mt-1"
                                                                    :pattern="item.pattern"
                                                                    :sizeNominal="0"
                                                                    :showCross="false"
                                                                    :falseCore="false"
                                                                    :ellipseRatio="0"
                                                                    :rotate="0"
                                                                    :patternSolidBG="patternSolidBG"
                                                                    :rotatePattern="rotatePattern"
                                                                    sideSize="110"
                                                                />
                                                            </div>
                                                            <div class="thumb-info">
                                                                <span class="number">{{ index + 1 }}.</span>
                                                                <span class="data">{{ item.info.output.toFixed(2) }}%</span>
                                                            </div>
                                                            <div class="edit-mark">
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon
                                                                            v-if="!$obj.isEmpty(item.recalcLogInfo)"
                                                                            v-on="on"
                                                                        >mdi-pencil-outline</v-icon>
                                                                    </template>
                                                                    <span>{{ $t("edited") }}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <v-divider class="mt-4" v-if="index < resByVol.length - 1"></v-divider>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <v-expansion-panel-content>
                                                <template v-slot:header>
                                                    <div>{{ $t("byPrice") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text
                                                        v-if="resByVol.length > 0"
                                                    >
                                                        <div
                                                            v-for="(item, index) in resByPrice"
                                                            :key="index"
                                                            class="text-xs-center mb-2 c-pointer"
                                                            @click="showInfoTable(resByPrice, 'price', index)"
                                                        >
                                                            <div class="pattern-thumb-container">
                                                                <pattern-vue
                                                                    class="thumb mt-1"
                                                                    :pattern="item.pattern"
                                                                    :sizeNominal="0"
                                                                    :showCross="false"
                                                                    :falseCore="false"
                                                                    :ellipseRatio="0"
                                                                    :rotate="0"
                                                                    :patternSolidBG="patternSolidBG"
                                                                    :rotatePattern="rotatePattern"
                                                                    sideSize="110"
                                                                />
                                                            </div>
                                                            <div class="thumb-info">
                                                                <span class="number">{{ index + 1 }}.</span>
                                                                <span class="data">{{ item.totalPrice.toFixed(2) }}</span>
                                                            </div>
                                                            <div class="edit-mark">
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon
                                                                            v-if="!$obj.isEmpty(item.recalcLogInfo)"
                                                                            v-on="on"
                                                                        >mdi-pencil-outline</v-icon>
                                                                    </template>
                                                                    <span>{{ $t("edited") }}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <v-divider class="mt-4" v-if="index < resByPrice.length - 1"></v-divider>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <v-expansion-panel-content>
                                                <template v-slot:header>
                                                    <div>{{ $t("byCantWidth") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text
                                                        v-if="resByVol.length > 0"
                                                    >
                                                        <div
                                                            v-for="(item, index) in resByCantWidth"
                                                            :key="index"
                                                            class="text-xs-center mb-2 c-pointer"
                                                            @click="showInfoTable(resByCantWidth, 'cant', index)"
                                                        >
                                                            <div class="pattern-thumb-container">
                                                                <pattern-vue
                                                                    class="thumb mt-1"
                                                                    :pattern="item.pattern"
                                                                    :sizeNominal="0"
                                                                    :showCross="false"
                                                                    :falseCore="false"
                                                                    :ellipseRatio="0"
                                                                    :rotate="0"
                                                                    :patternSolidBG="patternSolidBG"
                                                                    :rotatePattern="rotatePattern"
                                                                    sideSize="110"
                                                                />
                                                            </div>
                                                            <div class="thumb-info">
                                                                <span class="number">{{ index + 1 }}.</span>
                                                                <span class="data">{{ item.maxWidth }}</span>
                                                            </div>
                                                            <div class="edit-mark">
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon
                                                                            v-if="!$obj.isEmpty(item.recalcLogInfo)"
                                                                            v-on="on"
                                                                        >mdi-pencil-outline</v-icon>
                                                                    </template>
                                                                    <span>{{ $t("edited") }}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <v-divider class="mt-4" v-if="index < resByCantWidth.length - 1"></v-divider>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-sheet>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <calc-error-dialog    ref="CalcErrorDialog"/>
            <edit-pattern-dialog  :showPatternDiameter="false"
                                  ref="EditPatternDialog"/>
            <message-box          ref="MessageBox"/>
            <save-calculation-dialog   ref="SaveCalculationDialog"/>
            <saved-calculations-dialog ref="SavedCalculationsDialog"/>
            <select-cuts-dialog   ref="SelectCutsDialog"/>
            <tasks-history-dialog ref="TasksHistoryDialog"/>
            <text-input-dialog    ref="TextInputDialog"/>
            <three-d-pattern-view :pattern="pattern"
                                  ref="ThreeDPatternView"/>
            <pattern-print-dialog ref="PatternPrintDialog"/>
            <PatternPrintParamsDialog ref="PatternPrintParamsDialog"/>

            <v-alert
                :value="dataSavedAlert"
                type="success"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ $t("dataSaved") }}
            </v-alert>
            <v-alert
                :value="showCalculateAlert
                        && (!calcEnabled && (calcEnabled || !$store.getters.helpDisplayed) && (calcEnabled || !($refs.SelectCutsDialog != undefined ? $refs.SelectCutsDialog.dialog : false)))"
                type="error"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ $t("disableCalculationMessage") }}
                <v-btn
                    v-if="equipmentProfiles.length == 0"
                    flat small outline
                    @click="$router.replace({ path: '/equipment' })"
                    color="white"
                >
                    {{ $t("clickToNavigate") }}
                </v-btn>
                <v-btn
                    v-else
                    flat small outline
                    @click="showSelectCutsDialog()"
                    color="white"
                >
                    {{ $t("clickToNavigate") }}
                </v-btn>

            </v-alert>
        </v-layout>
    </v-container>
</template>

<script>
    import html2canvas from 'html2canvas';

    import CalcErrorDialog    from "@/components/dialogs/CalcErrorDialog";
    import EditPatternDialog  from "@/components/dialogs/EditPatternDialog";
    import MessageBox         from "@/components/dialogs/MessageBox";
    import PatternVue         from "@/components/patterns/PatternVue";
    import SaveCalculationDialog   from "@/components/dialogs/SaveCalculationDialog.vue";
    import SavedCalculationsDialog from "@/components/dialogs/SavedCalculationsDialog.vue";
    import SelectCutsDialog   from "@/components/dialogs/SelectCutsDialog";
    import TasksHistoryDialog from "@/components/dialogs/TasksHistoryDialog";
    import TextInputDialog    from "@/components/dialogs/TextInputDialog";
    import ThreeDPatternView  from "@/components/patterns/ThreeDPatternView";
    import PatternPrintDialog from "@/components/dialogs/PatternPrintDialog";
    import PatternPrintParamsDialog from "@/components/dialogs/PatternPrintParamsDialog";

    export default {
        name: "OptimizationForm",

        inject: ["theme"],

        components: {
            CalcErrorDialog,
            EditPatternDialog,
            MessageBox,
            PatternVue,
            SaveCalculationDialog,
            SavedCalculationsDialog,
            SelectCutsDialog,
            TasksHistoryDialog,
            TextInputDialog,
            ThreeDPatternView,
            PatternPrintDialog,
            PatternPrintParamsDialog,
        },

        data () {
            return {
                visible: false,

                updateUserSettings: true,

                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                aclPatterns: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },

                boardsHeader: [
                    { text: "Сечение",    align: "left", value: "size" },
                    { text: "Длина, м",   align: "left", value: "length" },
                    { text: "Цена за м3", align: "left", value: "price" },
                ],
                boardsCentral: [],
                boardsSide: [],

                breadCrumbs: [
                    { text: "Оптимизация", disabled: false }
                ],

                calculatedHeader: [
                    { text: "Сечение",   align: "left", value: "size",   sortable: false },
                    { text: "Длина, м",  align: "left", value: "length", sortable: false },
                    { text: "Кол-во",    align: "left", value: "qty",    sortable: false },
                    { text: "Объем, м3", align: "left", value: "volume", sortable: false },
                    { text: "Цена",      align: "left", value: "price",  sortable: false },
                ],
                calculatedData: [],

                curvatureSliderLabels: ["комель", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "вершина"],

                downloadType: [
                    { text: "Файл .pattern", value: "file" },
                    { text: "Скриншот постава", value: "screen-pattern"},
                    { text: "Скриншот постава с параметрами", value: "screen-info"},
                    { text: "Скриншот постава с полной информацией", value: "screen-full"}
                ],
/*
                lengthsHeader: [
                    { text: "Длина, м", align: "left", value: "length" },
                    { text: "Выбрано",  align: "left", value: "selected" }
                ],
*/
                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    logsAmount: value => (value >= 1 && value <= 10000) || this.$t("incorrectValue"),
                    dTop:      value => (value >= 50 && value <= 999) || this.$t("incorrectValue"),
                    falseCore: value => (value >= 0 && value <= 50) || this.$t("incorrectValue"),
                    length:    value => (value >= 1 && value <= 10) || this.$t("incorrectValue"),
                    taper:     value => (value >= 0 && value <= 30) || this.$t("incorrectValue"),
                    curvature: value => (value >= 0.0 && value <= 2.0) || this.$t("incorrectValue"),
                    corelessBoardThickness: value => (value >= 0 && value <= 600) || this.$t("incorrectValue"),
                    corelessBoardPrice:     value => value >=0  || this.$t("incorrectValue"),
                    ellipse:   value => (value >= 0.0 && value <= 10.0) || this.$t("incorrectValue"),
                    requiredNumAllowZero:   value => (!!value || value == 0) || this.$t("requiredField"),
                },

                corelessBoardPrice: 0,
                corelessBoardThickness: 10,
                curvature: 0.0,
                curvatureCenter: 0.5,
                dataSavedAlert: false,
                dialogWatcher: null,
                dTop: 200,
                equipmentProfiles: [],
                ellipseRatio: 0,
                rotate: 0,
                falseCore: 0,
                leftPanel: [true, true, true, true, true, true],
                length: 5.0,
                lengthsMenuProps: {
                    "closeOnClick":        false,
                    "closeOnContentClick": false,
                    "openOnClick":         true,
                    "maxHeight":           130
                },
                lengths: [],
                loading: {
                    calculationResult: false,
                    equipmentProfiles: false,
                    lumberInfo:        false,
                    pricesInfo:        false,
                    speciesInfo:       false
                },
                logInfo: {
                    dBottom:    0,
                    dTop:       0,
                    length:     0,
                    species:    null,
                    volume:     0,
                    curvature:  0,
                    curvCenter: 0
                },
                logsAmount: 1,
                minLen: 0,
                maxLen: 0,
                methods: [
                    { code: "vol",   name: "По объёму" },
                    { code: "price", name: "По цене" },
                    // { code: "width", name: "По ширине бруса" }
                ],
                optMethod: "vol",
                optPanel: 0,
                output: 0,
                outputRaw: 0,
                pattern: {},
                patternsLimit: 1,
                printType: [
                    { text: "Текущий постав", value: "pattern" },
                    { text: "Партия бревен", value: "batch" }
                ],
                prices: [],
                resByCantWidth: [],
                resByPrice: [],
                resByVol: [],
                resGroup: "volume",
                resIndex: 0,
                results: [],
                saveActive: false,
                sawAxis: 0,
                selectedLengths: [],
                selectedGroup: [],
                sizeNominal: 1, //"1",
                species: [],
                speciesId: 0,
                speciesLoaded: false,
                taper: 8, //0.72,
                taskId: 0,
                totalPrice: 0,
                equipmentId: 0,
                volume: 0.0,
                calcTimestamp: null,
                useWane: false,
                useCorelessBoard: false,
                useCentralAsSide: false,
                rotatePattern: false,
                patternSolidBG: false,
                showAxes:       true,
                showCutScheme:   false,
                showCalculateAlert: false
            }
        },

        watch: {
            dTop:                   function (val) { localStorage.opt1DTop = val; },
            length:                 function (val) { localStorage.opt1LogLength = val; },
            taper:                  function (val) { localStorage.opt1Taper = val; },
            pattern:                function (val) { this.saveActive = Object.entries(val).length > 0 && val.constructor === Object; },
            speciesId:              function (val) { this.getUserSettings(); localStorage.opt1SpeciesId = val; },
            useWane:                function (val) { localStorage.opt1UseWane = val; },
            useCorelessBoard:       function (val) { localStorage.opt1UseCorelessBoard = val; },
            corelessBoardPrice:     function (val) { localStorage.opt1CorelessBoardPrice = val; },
            corelessBoardThickness: function (val) { localStorage.opt1CorelessBoardThickness = val; },
            equipmentId:            function (val) { localStorage.opt1EquipmentId = val; },
            curvature:              function (val) { localStorage.opt1Curvature = val; },
            curvatureCenter:        function (val) { localStorage.opt1CurvatureCenter = val; },
            ellipseRatio:           function (val) { localStorage.opt1EllipseRatio = val; },
            rotate:                 function (val) { localStorage.opt1Rotate = val; },
            sizeNominal:            function (val) { localStorage.sizeNominal = val; },

            dataSavedAlert: function (val) {
                if (val) {
                    setTimeout(() => this.dataSavedAlert = false, 1500);
                }
            },

            resGroup: function (val) {
                //this.selectedGroup = [];
                if (val == "cant") {
                    this.selectedGroup = this.resByCantWidth;
                } else if (val == "price") {
                    this.selectedGroup = this.resByPrice;
                } else if (val == "volume") {
                    this.selectedGroup = this.resByVol;
                }

                this.$refs.PatternVue.updatePattern(this.pattern);
            },

        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.calculationResult || this.loading.equipmentProfiles
                    || this.loading.lumberInfo || this.loading.pricesInfo || this.loading.speciesInfo;
            },

            showPatternInfo () {
                return (this.logInfo.species !== null && this.logInfo.species.trim() !== "");
                // || this.totalPrice !== 0 || this.output.toFixed(2) !== 0.00
                //    || this.logInfo.volume !== 0 || this.logInfo.dTop !== 0 || this.logInfo.dBottom !== 0 || this.logInfo.length !== 0;
            },

            speciesFiltered () {
                return this.species.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id));
            },

            useStdTable () {
                return this.$store.getters.settings.volCalc.method == "standardTables";
            },

            useUserVolumeInput () {
                return this.$store.getters.settings.volCalc.method == "userVolumeInput";
            },

            calcEnabled () {
                return this.equipmentId != 0
                       && this.equipmentProfiles.length != 0
                       && (this.boardsSide.length != 0 || this.boardsCentral != 0);
            },

            pattern3DEnable () {
                return this.results.length > 0;
            }

        },

        async mounted () {
            if (!this.$store.getters.user.loggedIn) {
                localStorage.routerPath = "/optimization";
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            if (this.$store.getters.calculationTask.calculated) {
                this.getTaskResult (this.$store.getters.calculationTask.id)

                this.$store.commit("setCalculationTask", {id: 0, calculated: false});
            }

            if (localStorage.dTop) {
                localStorage.opt1DTop = localStorage.dTop;
                localStorage.removeItem('dTop');
            }
            if (localStorage.logLength) {
                localStorage.opt1LogLength = localStorage.logLength;
                localStorage.removeItem('logLength');
            }
            if (localStorage.taper) {
                localStorage.opt1Taper = localStorage.taper;
                localStorage.removeItem('taper');
            }
            if (localStorage.speciesId) {
                localStorage.opt1SpeciesId = localStorage.speciesId;
                localStorage.removeItem('speciesId');
            }
            if (localStorage.useWane) {
                localStorage.opt1UseWane = localStorage.useWane;
                localStorage.removeItem('useWane');
            }
            if (localStorage.useCorelessBoard) {
                localStorage.opt1UseCorelessBoard = localStorage.useCorelessBoard;
                localStorage.removeItem('useCorelessBoard');
            }
            if (localStorage.equipmentId) {
                localStorage.opt1EquipmentId = localStorage.equipmentId;
                localStorage.removeItem('equipmentId');
            }
            if (localStorage.curvature) {
                localStorage.opt1Curvature = localStorage.curvature;
                localStorage.removeItem('curvature');
            }
            if (localStorage.curvatureCenter) {
                localStorage.opt1CurvatureCenter = localStorage.curvatureCenter;
                localStorage.removeItem('curvatureCenter');
            }
            if (localStorage.corelessBoardThickness) {
                localStorage.opt1CorelessBoardThickness = localStorage.corelessBoardThickness;
                localStorage.removeItem('corelessBoardThickness');
            }
            if (localStorage.corelessBoardPrice) {
                localStorage.opt1CorelessBoardPrice = localStorage.corelessBoardPrice;
                localStorage.removeItem('corelessBoardPrice');
            }
            if (localStorage.ellipseRatio) {
                localStorage.opt1EllipseRatio = localStorage.ellipseRatio;
                localStorage.removeItem('ellipseRatio');
            }
            if (localStorage.rotate) {
                localStorage.opt1Rotate = localStorage.rotate;
                localStorage.removeItem('rotate');
            }

            this.dTop                   = localStorage.opt1DTop      ? localStorage.opt1DTop      : 200;
            this.length                 = localStorage.opt1LogLength ? localStorage.opt1LogLength : 5.0;
            this.taper                  = localStorage.opt1Taper     ? localStorage.opt1Taper     : 8.1;
            this.speciesId              = localStorage.opt1SpeciesId ? parseInt(localStorage.opt1SpeciesId) : 0;
            this.useWane                = localStorage.opt1UseWane   ? JSON.parse(localStorage.opt1UseWane) : false;
            this.useCorelessBoard       = localStorage.opt1UseCorelessBoard ? JSON.parse(localStorage.opt1UseCorelessBoard) : false;
            this.useCentralAsSide       = localStorage.useCentralAsSide ? JSON.parse(localStorage.useCentralAsSide) : false;
            this.equipmentId            = localStorage.opt1EquipmentId ? parseInt(localStorage.opt1EquipmentId) : 0;
            this.curvature              = localStorage.opt1Curvature   ? parseFloat(localStorage.opt1Curvature) : 0.0;
            this.curvatureCenter        = localStorage.opt1CurvatureCenter ? parseFloat(localStorage.opt1CurvatureCenter) : 0.5;
            this.corelessBoardThickness = localStorage.opt1CorelessBoardThickness ? parseInt(localStorage.opt1CorelessBoardThickness) : 1;
            this.corelessBoardPrice     = localStorage.opt1CorelessBoardPrice     ? parseFloat(localStorage.opt1CorelessBoardPrice)   : 0;
            this.ellipseRatio           = localStorage.opt1EllipseRatio ? parseFloat(localStorage.opt1EllipseRatio) : 0;
            this.rotate                 = localStorage.opt1Rotate       ? parseFloat(localStorage.opt1Rotate) : 0;
            this.sizeNominal            = localStorage.sizeNominal  ? parseInt(localStorage.sizeNominal) : 1;

            let user = this.$store.getters.user;

            this.patternSolidBG = user.settings == undefined ? false : user.settings.patternSolidBG;
            this.rotatePattern  = user.settings == undefined ? false : user.settings.rotatePattern;
            this.showAxes       = user.settings == undefined ? true  : user.settings.showAxes;

            this.applyLocale();
            this.getEquipmentProfiles();
            //await this.getLumber(true);
            this.getPrices();
            this.getSpecies();
            this.getUserSettings();
            this.loadLengths();

            this.patternsLimit = this.$store.getters.subscription.limits.maxPatterns
                ? this.$store.getters.subscription.limits.maxPatterns
                : 1;

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "calc") {
                        this.acl = aclRecord;
                    } else if (aclRecord.Module.Name == "patterns") {
                        this.aclPatterns = aclRecord;
                    }
                });
            }

            /**
             * Отслеживание изменения флага применения параметров кривизны
             */
            this.$watch(
                "$refs.CurvatureDialog.apply",
                (val) => {
                    if (val) {
                        this.curvatureCenter = this.$refs.CurvatureDialog.curvatureCenter;
                        this.sawAxis         = this.$refs.CurvatureDialog.sawAxis;
                    }
                }
            );

            /**
             * Отслеживание флага применения параметров в диалоге выбора сечений
             */
            this.$watch(
                "$refs.SelectCutsDialog.apply",
                (val) => {
                    if (val) {
                        // this.$debug.log("select");
                        localStorage.useCentralAsSide = this.$refs.SelectCutsDialog.useCentralAsSide;
                        this.useCentralAsSide = this.$refs.SelectCutsDialog.useCentralAsSide;

                        this.boardsSide    = [...this.$refs.SelectCutsDialog.sideBoardsSelected];
                        this.boardsCentral = [...this.$refs.SelectCutsDialog.centralBoardsSelected];

                        let elem = this;
                        if (this.$refs.SelectCutsDialog.useCentralAsSide) {
                            this.boardsCentral.forEach((board) => {
                                elem.boardsSide.push(board);
                            });
                        }

                        localStorage.setItem("boards_side_" + this.speciesId,    JSON.stringify(this.boardsSide));
                        localStorage.setItem("boards_central_" + this.speciesId, JSON.stringify(this.boardsCentral));

                        this.$refs.SelectCutsDialog.resetForm();
                    }

                }
            );

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            if (this.$store.getters.subscription.settings.optimization.lockWane) {
                this.opt1UseWane = false;
                localStorage.opt1UseWane = false;
            }
            if (this.$store.getters.subscription.settings.optimization.lockCoreLess) {
                this.opt1UseCorelessBoard = false;
                localStorage.opt1UseCorelessBoard = false;
            }
            if (this.$store.getters.subscription.settings.optimization.lockCurvature) {
                this.curvature = 0;
                localStorage.opt1Curvature = 0;
                this.ellipseRatio = 0;
                localStorage.opt1EllipseRatio = 0;
                //this.rotate = 0;
                //localStorage.rotate = 0;
            }
        },

        methods: {
            applyLocale () {
                this.calculatedHeader = [
                    { text: this.$t("dimension"),                     align: "left",  value: "size",    sortable: false },
                    { text: `${this.$t("length")}, ${this.$t("m")}`,  align: "left",  value: "length",  sortable: false },
                    { text: this.$t("amountShort"),                   align: "left",  value: "qty",     sortable: false },
                    { text: `${this.$t("volume")}, ${this.$t("m3")}`, align: "left",  value: "volume",  sortable: false },
                    { text: `${this.$t("output")}`,                   align: "left",  value: "percent", sortable: false },
                    { text: this.$t("price"),                         align: "right", value: "price",   sortable: false }
                ],

                this.curvatureSliderLabels = [this.$t("top").toLowerCase(), "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", this.$t("bottom").toLowerCase()],

                this.boardsHeader = [
                    { text: this.$t("dimension"), align: "left", value: "size" },
                    { text: this.$t("length") + ", " + this.$t("m"), align: "left", value: "length" },
                    { text: this.$t("price"), align: "right", value: "price" },
                    { text: this.$t("expenses"), align: "right", value: "expenses" },
                ],

                this.breadCrumbs = [
                    { text: this.$t("optimization"), disabled: false }
                ];

                this.downloadType = [
                    { text: this.$t("patternFile"), value: "file" },
                    { text: this.$t("screenPattern"), value: "screen-pattern"},
                    { text: this.$t("screenPatternWitnInfo"), value: "screen-info"},
                    { text: this.$t("screenPatternWithFullInfo"), value: "screen-full"}
                ];

                this.printType = [
                    { text: this.$t("currentPattern"), value: "pattern" },
                    { text: this.$t("batchOfLogs"),    value: "batch" }
                ];

                this.methods = [
                    { code: "vol",   name: this.$t("byVolume") },
                    { code: "price", name: this.$t("byPrice") },
                    //{ code: "width", name: this.$t("byCantWidth") }
                ];

                this.getSpecies();

                if (this.resGroup == "cant") {
                    this.showInfoTable(this.resByCantWidth, 'cant', this.resIndex);
                } else if (this.resGroup == "price") {
                    this.showInfoTable(this.resByPrice, 'price', this.resIndex);
                } else if (this.resGroup == "volume") {
                    this.showInfoTable(this.resByVol, 'volume', this.resIndex);
                }
            },

            /**
             * Выполнение расчёта
             */
            calculate () {
                //Сбрасываем начальную позицию 3Д модели для нового расчёта
                this.$refs.ThreeDPatternView.cameraPosition.z = 0;

                this.resetData();

                let task = {
                    speciesId: parseInt(this.speciesId),
                    method:    this.optMethod,
                    lineId: parseInt(this.equipmentId),
                    line:      [], //this.equipmentProfiles[this.equipmentId],
                    boards: {
                        central: [], //this.boardsCentral,
                        side:    [], //this.boardsSide
                    },
                    log: {
                        dTop:            this.dTop,
                        l:               this.length,
                        falseCore:       this.falseCore,
                        taper:           parseFloat(this.taper),
                        curvature:       parseFloat(this.curvature),
                        curvatureCenter: this.curvatureCenter,
                        ellipseRatio:    this.ellipseRatio,
                        rotationAngle:   this.rotate,
                        volume:          parseFloat(this.volume)
                    },
                    useWane: this.useWane,
                    corelessBoard: {
                        enabled:   this.useCorelessBoard,
                        thickness: parseFloat(this.corelessBoardThickness),
                        price:     parseFloat(this.corelessBoardPrice)
                    }
                };

                this.boardsCentral.forEach((val) => {
                    task.boards.central.push(this.parseBoardInfo(val))
                });

                this.boardsSide.forEach((val) => {
                    task.boards.side.push(this.parseBoardInfo(val))
                });

                this.equipmentProfiles.forEach((profile) => {
                    if (profile.id == this.equipmentId) {
                        profile.data.forEach((val) => {
                            task.line.push(this.parseEquipmentInfo(val));
                        });
                    }
                });

                this.loading.calculationResult = true;

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}tasks/`,
                    data: {
                        type:     1,    // 1 - Оптимизация раскроя, 2 - Поиск оптимального диаметра, 3 - пересчёт постава
                        dataJSON: JSON.stringify(task)
                    },
                    withCredentials: true
                }).then(response => {
                    this.taskId = response.data.task.id;
                    this.callExternalApp(response.data.task.id, 1);
                    this.loading.calculationResult = false;
                }).catch(err => {
                    this.loading.calculationResult = false;

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `Optimization.vue -> calculate: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {  window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("calculationError"));
                    }
                });
            },

            /**
             * Вычисление объёма бревна по методу верхнего диаметра и среднего сбега
             */
            calculateVolume() {
                this.volume = (3.1415926 * parseFloat(this.length) * (parseInt(this.dTop) / 10 + parseFloat(this.taper / 100) * parseFloat(this.length) / 2) ** 2 / 40000).toFixed(4);

                if (isNaN(this.volume)) { this.volume = "-"; }
            },

            /**
             * Вызов внешнего приложения
             *
             * @param {number} taskId Идентификатор задачи
             * @param {number} taskType Тип оптимизации (1 - поиск поставов, 2 - редактирование результата)
             */
            callExternalApp(taskId, taskType) {
                this.loading.calculationResult = true;

                this.axios.get(`${this.$config.apiURL}calc/?task=${taskId}`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success" && taskType == 1) {
                            let responseData = JSON.parse(response.data.task.ResponseJSON);

                            if (responseData == null) {
                                throw "optimizerResponseIsNull";
                            }

                            if (responseData.error) {
                                if (typeof responseData.error == "string") {
                                    throw responseData.error;
                                }

                                this.showError(responseData);
                                this.resetData();
                                this.loading.calculationResult = false;

                                return;
                            }

                            let curTime = new Date();

                            this.calcTimestamp = curTime.toLocaleDateString() + " " + curTime.toLocaleTimeString();

                            this.logInfo.dTop = responseData.info !== undefined && responseData.info.diamTop !== undefined
                                ? responseData.info.diamTop
                                : 0;
                            this.logInfo.dBottom = responseData.info !== undefined && responseData.info.diamKomel !== undefined
                                ? parseInt(responseData.info.diamKomel)
                                : 0;
                            this.logInfo.length = responseData.info !== undefined && responseData.info.logLength !== undefined
                                ? responseData.info.logLength
                                : 0;
                            this.logInfo.taper = responseData.info !== undefined && responseData.info.taper !== undefined
                                ? responseData.info.taper.toFixed(1)
                                : this.taper;
                            this.logInfo.species = responseData.info !== undefined && responseData.info.species !== undefined
                                ? responseData.info.species
                                : "";
                            this.logInfo.volume = responseData.info !== undefined && responseData.info.logVolume !== undefined
                                ? responseData.info.logVolume.toFixed(5)
                                : 0;
                            this.logInfo.curvature = responseData.info !== undefined && responseData.info.curvature !== undefined
                                ? parseFloat(responseData.info.curvature.toFixed(3))
                                : 0;
                            this.logInfo.curvCenter = responseData.info !== undefined && responseData.info.curvatureCenter !== undefined
                                ? parseFloat(responseData.info.curvatureCenter.toFixed(3))
                                : 0;
                            this.logInfo.ellipseRatio = responseData.info !== undefined && responseData.info.ellipseRatio !== undefined
                                ? parseFloat(responseData.info.ellipseRatio.toFixed(2))
                                : 0;
                            this.logInfo.rotationAngle = responseData.info !== undefined && responseData.info.rotationAngle !== undefined
                                ? parseInt(responseData.info.rotationAngle)
                                : 0;

                            this.results = [...responseData.patternList];
                            this.results.forEach((result) => {
                                let totalVol   = 0;
                                let totalPrice = 0;

                                if (result.info.boards) {
                                    result.info.boards.forEach((board) => {
                                        totalVol   += board.volume; // * board.amount;
                                        totalPrice += board.price; // * board.amount;
                                    });

                                    totalPrice -= result.info.rawMaterials ? result.info.rawMaterials.price : 0;
                                    totalPrice -= result.info.expenses ? result.info.expenses.price : 0;
                                    totalPrice += result.info.sawDust ? result.info.sawDust.price : 0;
                                    totalPrice += result.info.woodChips ? result.info.woodChips.price : 0;
                                }

                                result.totalVol   = totalVol;
                                result.totalPrice = totalPrice;
                            });

                            this.results.forEach((result) => {
                                result.maxWidth = this.getMaxBoardWidth(result.pattern.items);
                                result.recalcLogInfo = {};
                            });

                            this.resByVol       = [...this.results];
                            this.resByPrice     = [...this.results];
                            this.resByCantWidth = [...this.results];

                            this.resByVol.sort((a, b) => {
                                return a.totalVol > b.totalVol ? -1 : 1;
                            });

                            this.resByPrice.sort((a, b) => {
                                return a.totalPrice > b.totalPrice ? -1 : 1;
                            });

                            this.resByCantWidth.sort((a, b) => {
                                return this.getMaxBoardWidth(a.pattern.items) > this.getMaxBoardWidth(b.pattern.items) ? -1 : 1;
                            });

                            this.showInfoTable(this.resByVol, 'volume', 0);

                            this.selectedGroup = this.resByVol;
                        } else if (response.data.status == "success" && taskType == 2) {
                            let responseData = JSON.parse(response.data.task.ResponseJSON);

                            if (responseData == null) {
                                throw "optimizerResponseIsNull";
                            }

                            if (responseData.error) {
                                if (typeof responseData.error == "string") {
                                    throw responseData.error;
                                }

                                this.showError(responseData);
                                this.resetData();
                                this.loading.calculationResult = false;

                                return;
                            }

                            this.pattern = {...responseData.patternList[0].pattern};

                            let totalVol   = 0;
                            let totalPrice = 0;

                            if (responseData.patternList[0].info.boards) {
                                responseData.patternList[0].info.boards.forEach((board) => {
                                    totalVol   += board.volume; // * board.amount;
                                    totalPrice += board.price; // * board.amount;
                                });

                                totalPrice -= responseData.patternList[0].info.rawMaterials ? responseData.patternList[0].info.rawMaterials.price : 0;
                                totalPrice -= responseData.patternList[0].info.expenses ? responseData.patternList[0].info.expenses.price : 0;
                                totalPrice += responseData.patternList[0].info.sawDust ? responseData.patternList[0].info.sawDust.price : 0;
                                totalPrice += responseData.patternList[0].info.woodChips ? responseData.patternList[0].info.woodChips.price : 0;
                            }

                            if (this.resGroup == "cant") {
                                this.resByCantWidth[this.resIndex].pattern    = {...responseData.patternList[0].pattern};
                                this.resByCantWidth[this.resIndex].info       = {...responseData.patternList[0].info};
                                this.resByCantWidth[this.resIndex].totalVol   = totalVol;
                                this.resByCantWidth[this.resIndex].totalPrice = totalPrice;
                                this.resByCantWidth[this.resIndex].recalcLogInfo.dTop      = responseData.info.diamTop;
                                this.resByCantWidth[this.resIndex].recalcLogInfo.dBottom   = parseInt(responseData.info.diamKomel);
                                this.resByCantWidth[this.resIndex].recalcLogInfo.curvature = responseData.info.curvature.toFixed(2);
                                this.resByCantWidth[this.resIndex].recalcLogInfo.ellipseRatio    = responseData.info.ellipseRatio.toFixed(2);
                                this.resByCantWidth[this.resIndex].recalcLogInfo.rotationAngle   = responseData.info.rotationAngle;
                                this.resByCantWidth[this.resIndex].recalcLogInfo.volume     = responseData.info.logVolume.toFixed(5);
                                this.resByCantWidth[this.resIndex].recalcLogInfo.len        = responseData.info.logLength.toFixed(2);
                                this.resByCantWidth[this.resIndex].recalcLogInfo.taper          = responseData.info.taper.toFixed(2);
                                this.showInfoTable(this.resByCantWidth, 'cant', this.resIndex);
                            } else if (this.resGroup == "price") {
                                this.resByPrice[this.resIndex].pattern    = {...responseData.patternList[0].pattern};
                                this.resByPrice[this.resIndex].info       = {...responseData.patternList[0].info};
                                this.resByPrice[this.resIndex].totalVol   = totalVol;
                                this.resByPrice[this.resIndex].totalPrice = totalPrice;
                                this.resByPrice[this.resIndex].recalcLogInfo.dTop          = responseData.info.diamTop;
                                this.resByPrice[this.resIndex].recalcLogInfo.dBottom       = parseInt(responseData.info.diamKomel);
                                this.resByPrice[this.resIndex].recalcLogInfo.curvature     = responseData.info.curvature.toFixed(2);
                                this.resByPrice[this.resIndex].recalcLogInfo.ellipseRatio  = responseData.info.ellipseRatio.toFixed(2);
                                this.resByPrice[this.resIndex].recalcLogInfo.rotationAngle = responseData.info.rotationAngle;
                                this.resByPrice[this.resIndex].recalcLogInfo.volume        = responseData.info.logVolume.toFixed(5);
                                this.resByPrice[this.resIndex].recalcLogInfo.len           = responseData.info.logLength.toFixed(2);
                                this.resByPrice[this.resIndex].recalcLogInfo.taper         = responseData.info.taper.toFixed(2);
                                this.showInfoTable(this.resByPrice, 'price', this.resIndex);
                            } else if (this.resGroup == "volume") {
                                this.resByVol[this.resIndex].pattern    = {...responseData.patternList[0].pattern};
                                this.resByVol[this.resIndex].info       = {...responseData.patternList[0].info};
                                this.resByVol[this.resIndex].totalVol   = totalVol;
                                this.resByVol[this.resIndex].totalPrice = totalPrice;
                                this.resByVol[this.resIndex].recalcLogInfo.dTop            = responseData.info.diamTop;
                                this.resByVol[this.resIndex].recalcLogInfo.dBottom         = parseInt(responseData.info.diamKomel);
                                this.resByVol[this.resIndex].recalcLogInfo.curvature       = responseData.info.curvature.toFixed(2);
                                this.resByVol[this.resIndex].recalcLogInfo.ellipseRatio    = responseData.info.ellipseRatio.toFixed(2);
                                this.resByVol[this.resIndex].recalcLogInfo.rotationAngle   = responseData.info.rotationAngle;
                                this.resByVol[this.resIndex].recalcLogInfo.volume          = responseData.info.logVolume.toFixed(5);
                                this.resByVol[this.resIndex].recalcLogInfo.len             = responseData.info.logLength.toFixed(2);
                                this.resByVol[this.resIndex].recalcLogInfo.taper           = responseData.info.taper.toFixed(2);
                                this.showInfoTable(this.resByVol, 'volume', this.resIndex);
                            }
                        }

                        this.loading.calculationResult = false;
                    })
                    .catch(err => {
                        this.loading.calculationResult = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> callExternalApp: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (typeof err == "string") {
                            this.showMessageBox(this.$t("information"), this.$t(err));
                        } else if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("applicationError"));
                        }
                    });
            },

            /**
             * Выгрузка постава в формате .pattern
             */
            downloadPatternClick (type) {
                let curTimestamp = new Date();
                const filename = this.$t("pattern") + " "
                    + curTimestamp.toLocaleDateString() + " "
                    + curTimestamp.toLocaleTimeString();

                if (type == "file") {
                    let pattern     = this.$refs.PatternVue.getPattern();
                    pattern.species = this.logInfo.species;

                    delete pattern.info;
                    let jsonContent        = "data:application/json;charset=utf-8," + encodeURIComponent(JSON.stringify(pattern));
                    let downloadAnchorNode = document.createElement("a");

                    downloadAnchorNode.setAttribute("href", jsonContent);
                    downloadAnchorNode.setAttribute("download", `${filename}.pattern`);
                    document.body.appendChild(downloadAnchorNode); // required for firefox
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                } else {
                    // Указываем элемент, который нужно "сфотографировать"
                    const element = document.getElementById(type);

                    // Используем html2canvas для создания изображения
                    html2canvas(element, {
                        ignoreElements: (el) => el.classList.contains('ignore-element')
                    }).then((canvas) => {
                        // Преобразуем canvas в data URL (изображение в формате PNG)
                        const imgData = canvas.toDataURL('image/png');

                        // Создаем временную ссылку для скачивания
                        const link = document.createElement('a');
                        link.href = imgData;
                        link.download = `${filename}.png`; // Имя файла

                        // Программно кликаем по ссылке, чтобы скачать файл
                        link.click();
                    });
                }
            },

            formattedLengthsString (lengths) {
                let result = "";

                lengths.split(",").forEach(len => result += `${ this.$num.dropZeros(len) }, `);

                return result.indexOf(",") == -1
                    ? result
                    : result.substring(0, result.lastIndexOf(","));
            },

            /**
             * Функция срабатывающая при открытии диалог временного изменения длины сечений
             * подгружает имеющиеся значения длин
             *
             * @param {board} object Парметры выбранного сечения
             */
            openEditLengthDialog (board) {
                this.selectedLengths = board.selectedLengths;
            },

            /**
             * Функция срабатывающая при закрытии диалог временного изменения длины сечений
             * сортировка и сохранение выбранных значений
             *
             * @param {board} object Парметры выбранного сечения
             */
            closeEditLengthDialog (board) {
                let lenRange = "";

                if (this.selectedLengths.length == 0) {
                    board.selectedLengths = this.selectedLengths;
                    board.length = "-";

                    return
                }

                this.selectedLengths.sort((a, b) => {
                    return a.length > b.length;
                });

                board.selectedLengths = this.selectedLengths;
                this.selectedLengths.forEach((lenItem, index) => {
                    lenRange += index ? ", " : "";
                    lenRange += lenItem.length.toString();
                });

                board.length = lenRange;
            },

            /**
             * Обработчик нажатия кнопки печати постава
             */
            printPatternClick (type) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                if (type == "pattern") {
                    /* Отслеживание ответа в диалоге "Да/Нет" */
                    this.dialogWatcher = this.$watch(
                        "$refs.TextInputDialog.answer",
                        (val) => {
                            if (val) {
                                this.logsAmount = 1;
                                this.$refs.PatternPrintDialog.patternName = this.$refs.TextInputDialog.textInput;
                                this.printPattern(type);
                            }
                        }
                    );

                    let curTimestamp = new Date();

                    this.$refs.TextInputDialog.answer    = null;
                    this.$refs.TextInputDialog.title     = this.$t("print");
                    this.$refs.TextInputDialog.hintText  = this.$t("patternName");
                    this.$refs.TextInputDialog.textInput = `${this.$t("pattern")} - D${parseInt(this.logInfo.dTop/10)}, ${curTimestamp.toLocaleDateString()}`;
                    this.$refs.TextInputDialog.dialog    = true;
                } else if (type == "batch") {
                    this.dialogWatcher = this.$watch(
                        "$refs.PatternPrintParamsDialog.answer",
                        async (val) => {
                            if (val) {
                                this.logsAmount = parseInt(this.$refs.PatternPrintParamsDialog.logsAmount);

                                this.$refs.PatternPrintDialog.logsAmount       = parseInt(this.$refs.PatternPrintParamsDialog.logsAmount);
                                this.$refs.PatternPrintDialog.printSawWaste    = this.$refs.PatternPrintParamsDialog.useSawWaste;
                                this.$refs.PatternPrintDialog.printRawMaterial = this.$refs.PatternPrintParamsDialog.useRawMaterials;
                                this.printPattern(type);
                            }
                        }
                    );

                    this.$refs.PatternPrintParamsDialog.dialog = true;
                }

            },

            /**
             * Печать постава
             *
             * @param {text} type Тип печати
             *
             */
            async printPattern (type) {
                this.showInfoTable(this.resByVol, 'volume', this.resIndex);

                this.$refs.PatternPrintDialog.printType   = type;
                this.$refs.PatternPrintDialog.pattern     = this.pattern;
                this.$refs.PatternPrintDialog.sizeNominal = this.sizeNominal;
                this.$refs.PatternPrintDialog.showCutScheme = this.showCutScheme;
                this.$refs.PatternPrintDialog.falseCore   = this.falseCore;
                this.$refs.PatternPrintDialog.logInfo     = {...this.logInfo};
                this.$refs.PatternPrintDialog.logInfo.dTop      = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                ? this.logInfo.dTop
                                                                : this.selectedGroup[this.resIndex].recalcLogInfo.dTop;
                this.$refs.PatternPrintDialog.logInfo.dBottom   = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                ? this.logInfo.dBottom
                                                                : this.selectedGroup[this.resIndex].recalcLogInfo.dBottom;
                this.$refs.PatternPrintDialog.logInfo.curvature = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                ? this.logInfo.curvature
                                                                : parseFloat(this.selectedGroup[this.resIndex].recalcLogInfo.curvature);
                this.$refs.PatternPrintDialog.logInfo.volume    = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                ? this.logInfo.volume
                                                                : this.selectedGroup[this.resIndex].recalcLogInfo.volume;
                this.$refs.PatternPrintDialog.logInfo.ellipseRatio    = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                      ? this.logInfo.ellipseRatio
                                                                      : parseFloat(this.selectedGroup[this.resIndex].recalcLogInfo.ellipseRatio);
                this.$refs.PatternPrintDialog.logInfo.rotationAngle   = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                      ? this.logInfo.rotationAngle
                                                                      : this.selectedGroup[this.resIndex].recalcLogInfo.rotationAngle;
                this.$refs.PatternPrintDialog.logInfo.length   = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                                      ? this.logInfo.length
                                                                      : parseFloat(this.selectedGroup[this.resIndex].recalcLogInfo.len);
                this.$refs.PatternPrintDialog.output      = this.output;
                this.$refs.PatternPrintDialog.outputRaw   = this.outputRaw;
                this.$refs.PatternPrintDialog.totalPrice  = this.totalPrice;

                await Object.assign(this.$refs.PatternPrintDialog.tableHeader, this.calculatedHeader);
                await Object.assign(this.$refs.PatternPrintDialog.tableData, this.calculatedData);

                this.$refs.PatternPrintDialog.calcTimestamp = this.calcTimestamp;
                this.$refs.PatternPrintDialog.cuttingScheme = this.$refs.PatternVue.cuttingSchemeStr;

                this.$refs.PatternPrintDialog.dialog = true;
            },

            /**
             * Отображение постава в 3Д
             */
            show3DViewClick () {
                this.$refs.ThreeDPatternView.logInfo = {...this.logInfo};
                if (this.selectedGroup[this.resIndex] != null && !this.$obj.isEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)) {
                    this.$refs.ThreeDPatternView.logInfo.dBottom       = this.selectedGroup[this.resIndex].recalcLogInfo.dBottom;
                    this.$refs.ThreeDPatternView.logInfo.dTop          = this.selectedGroup[this.resIndex].recalcLogInfo.dTop;
                    this.$refs.ThreeDPatternView.logInfo.length        = parseFloat(this.selectedGroup[this.resIndex].recalcLogInfo.len);
                    this.$refs.ThreeDPatternView.logInfo.curvature     = parseFloat(this.selectedGroup[this.resIndex].recalcLogInfo.curvature);
                    this.$refs.ThreeDPatternView.logInfo.curvCenter    = 0.5;
                    this.$refs.ThreeDPatternView.logInfo.ellipseRatio  = parseFloat(this.selectedGroup[this.resIndex].recalcLogInfo.ellipseRatio);
                    this.$refs.ThreeDPatternView.logInfo.rotationAngle = this.selectedGroup[this.resIndex].recalcLogInfo.rotationAngle;
                }
                this.$refs.ThreeDPatternView.output        = this.output;
                this.$refs.ThreeDPatternView.totalPrice    = this.totalPrice;
                this.$refs.ThreeDPatternView.calcTimestamp = this.calcTimestamp;

                this.$refs.ThreeDPatternView.dialog = true;
            },

            /**
             * Получение данных о пиломатериалах
             *
             * @param {bool} updateOnly Будут обновлены данные только у выбранных пользователем пиломатериалов
             */
            getLumber (updateOnly = false) {
                this.loading.lumberInfo = true;

                let centralBoardsIds = [];
                let sideBoardsIds    = [];

                this.boardsCentral.forEach((board) => {
                    centralBoardsIds.push(board.id);
                });

                this.boardsSide.forEach((board) => {
                    sideBoardsIds.push(board.id);
                });

                this.axios.get(`${this.$config.apiURL}lumber/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lumberInfo = response.data.lumber

                            //this.equipmentProfiles = [];

                            if (!updateOnly) {
                                this.boardsCentral = [];
                                this.boardsSide    = [];
                            }

                            let boardsCentralTemp = [];
                            let boardsSideTemp    = [];

                            lumberInfo.forEach((item) => {
                                let lenRange = "";

                                JSON.parse(item.LengthsJSON).forEach((lenItem, index) => {
                                    lenRange += index ? ", " : "";
                                    lenRange += lenItem.length.slice(0, -1);
                                });

                                // Меняем значения стандартных сечений на ознакомительной подписке
                                if (this.$store.getters.subscription.id == 1) {
                                    item.Tn += 2;
                                    item.Wn += 2;
                                    item.Ts = parseFloat(item.Ts) + 2;
                                    item.Ws = parseFloat(item.Ws) + 2;
                                }

                                if (item.BoardType == 0 && item.Species.id == this.speciesId) {
                                    if (updateOnly) {
                                        if (centralBoardsIds.includes(item.id)) {
                                            boardsCentralTemp.push({
                                                id:      item.id,
                                                uid:     "c" + item.id,
                                                size:    item.Tn + " x " + item.Wn,
                                                sawSize: item.Ts + " x " + item.Ws,
                                                length:  lenRange,
                                                price:   item.Price,
                                                expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                                selectedLengths: JSON.parse(item.LengthsJSON)
                                            });

                                            if (this.useCentralAsSide) {
                                                boardsSideTemp.push({
                                                id:      item.id,
                                                uid:     "s" + item.id,
                                                size:    item.Tn + " x " + item.Wn,
                                                sawSize: item.Ts + " x " + item.Ws,
                                                length:  lenRange,
                                                price:   item.Price,
                                                expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                                selectedLengths: JSON.parse(item.LengthsJSON)
                                            });
                                            }
                                        }
                                    } else {
                                        this.boardsCentral.push({
                                            id:      item.id,
                                            uid:     "c" + item.id,
                                            size:    item.Tn + " x " + item.Wn,
                                            sawSize: item.Ts + " x " + item.Ws,
                                            length:  lenRange,
                                            price:   item.Price,
                                            expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                            selectedLengths: JSON.parse(item.LengthsJSON)
                                        });
                                    }
                                } else if (item.Species.id == this.speciesId) {
                                    if (updateOnly) {
                                        if (sideBoardsIds.includes(item.id)) {
                                            boardsSideTemp.push({
                                                id:      item.id,
                                                uid:     "s" + item.id,
                                                size:    item.Tn + " x " + item.Wn,
                                                sawSize: item.Ts + " x " + item.Ws,
                                                length:  lenRange,
                                                price:   item.Price,
                                                expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                                selectedLengths: JSON.parse(item.LengthsJSON)
                                            });
                                        }
                                    } else {
                                        this.boardsSide.push({
                                            id:      item.id,
                                            uid:     "s" + item.id,
                                            size:    item.Tn + " x " + item.Wn,
                                            sawSize: item.Ts + " x " + item.Ws,
                                            length:  lenRange,
                                            price:   item.Price,
                                            expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                            selectedLengths: JSON.parse(item.LengthsJSON)
                                        });
                                    }
                                }
                            });

                            if (updateOnly) {
                                this.boardsCentral = [...boardsCentralTemp];
                                this.boardsSide    = [...boardsSideTemp];
                            }
                        }
                        this.loading.lumberInfo = false;
                    })
                    .catch(err => {
                        this.loading.lumberInfo = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> getLumber: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData"));
                        }
                    });
            },

            /**
             * Возвращает максимальную ширину доски в поставе
             *
             * @param {array} items Массив с досками
             *
             * @returns {number} Максимальная ширина доски
             */
            getMaxBoardWidth (items) {
                let maxWidth = 0;

                let parent = this;
                items.forEach((item) => {
                    let max = 0;

                    if (item == null) {
                        return 0;
                    }

                    if (item.items !== undefined) {
                        max = parent.getMaxBoardWidth(item.items);
                        if (max > maxWidth) {
                            maxWidth = max;
                        }
                    } else {
                        if (maxWidth < item.wn) {
                            maxWidth = item.wn;
                        }
                    }
                });

                return maxWidth;
            },

            /**
             * Получение данных о профилях оборудования
             */
            getEquipmentProfiles () {
                this.loading.equipmentProfiles = true;

                this.axios.get(`${this.$config.apiURL}lines/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let profilesInfo = response.data.lines

                            this.equipmentProfiles = [];

                            profilesInfo.forEach((profileInfo) => {
                                this.equipmentProfiles.push({
                                    id:   profileInfo.id,
                                    name: profileInfo.Name,
                                    data: JSON.parse(profileInfo.DataJSON)
                                });
                            });

                            if (this.equipmentId == 0 && !localStorage.opt1EquipmentId) {
                                this.equipmentId = (profilesInfo.length == 0) ? 0 : this.equipmentProfiles[0].id;
                            }

                            this.loading.equipmentProfiles = false;
                            this.showCalculateAlert = true;
                        }
                    })
                    .catch(err => {
                        this.loading.equipmentProfiles = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> getEquipmentProfiles: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentProfiles") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentProfiles") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentProfiles"));
                        }
                    });
            },

            /**
             * Получение данных о ценах
             */
            getPrices () {
                this.loading.pricesInfo = true;

                this.axios.get(`${this.$config.apiURL}prices/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let pricesInfo = response.data.prices

                            this.prices = [];

                            pricesInfo.forEach((item) => {
                                this.prices.push({
                                    id:        item.id,
                                    speciesId: item.SpeciesId,
                                    dMin:      item.DMin,
                                    price:     item.Price
                                });
                            });
                        }
                        this.loading.pricesInfo = false;
                    })
                    .catch(err => {
                        this.loading.pricesInfo = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> getPrices: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData"));
                        }
                    });
            },

            /**
             * Получение данных о породах
             */
            getSpecies () {
                this.loading.speciesInfo = true;

                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        this.loading.speciesInfo = false;
                        this.speciesLoaded       = true;

                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.species = [];

                            speciesInfo.forEach((item) => {
                                this.species.push({
                                    id:   item.id,
                                    name: this.$t(item.Name)
                                });
                                if (this.speciesId == 0) {
                                    this.speciesId = item.id;
                                }
                            });

                            this.species.sort((a, b) => a.name > b.name);
                        }
                    })
                    .catch(err => {
                        this.loading.speciesInfo = false;
                        this.speciesLoaded       = true;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> getSpecies: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Получение результатов задания на расчёт
             *
             * @param {number} id Идентификатор задания
             */
            async getTaskResult (id) {
                this.taskId = id;

                this.loading.calculationResult = true;

                this.axios.get(`${this.$config.apiURL}tasks/${id}/`, { withCredentials: true })
                    .then( async response => {
                        if (response.data.status == "success") {
                            let responseData = JSON.parse(response.data.task.ResponseJSON);
                            let requestData = JSON.parse(response.data.task.RequestJSON);

                            if (responseData == null) {
                                throw "optimizerResponseIsNull";
                            }
/*
                            if (responseData.error !== undefined) { // && responseData.error == "unsupportedPattern") {
                                throw responseData.error;
                            }
*/
                            this.calcTimestamp = new Date(response.data.task.createdAt).toLocaleDateString() + " " + new Date(response.data.task.createdAt).toLocaleTimeString();

                            if (responseData.error) {
                                if (typeof responseData.error == "string") {
                                    throw responseData.error;
                                }

                                this.showError(responseData);
                                this.resetData();
                                this.loading.calculationResult = false;

                                return;
                            }

                            this.updateUserSettings = false;

                            this.optMethod = requestData !== undefined && requestData.method !== undefined
                                ? requestData.method
                                : "vol";
                            this.volume = requestData.log !== undefined && requestData.log.volume !== undefined
                                ? requestData.log.volume
                                : this.volume;
                            this.dTop = requestData.log !== undefined && requestData.log.dTop !== undefined
                                ? requestData.log.dTop
                                : this.dTop;
                            this.length = requestData.log !== undefined && requestData.log.l !== undefined
                                ? requestData.log.l
                                : this.length;
                            this.taper = requestData.log !== undefined && requestData.log.taper !== undefined
                                ? requestData.log.taper
                                : this.taper;
                            this.curvature = requestData.log !== undefined && requestData.log.curvature !== undefined
                                ? requestData.log.curvature
                                : this.curvature;
                            this.curvatureCenter = requestData.log !== undefined && requestData.log.curvatureCenter !== undefined
                                ? requestData.log.curvatureCenter
                                : this.curvatureCenter;
                            this.ellipseRatio = requestData.log !== undefined && requestData.log.ellipseRatio !== undefined
                                ? requestData.log.ellipseRatio
                                : this.ellipseRatio;
                            this.speciesId = requestData !== undefined && requestData.speciesId !== undefined
                                ? requestData.speciesId
                                : this.speciesId;
                            this.equipmentId = requestData !== undefined && requestData.lineId !== undefined
                                ? requestData.lineId
                                : this.equipmentId;
                            this.useWane = requestData !== undefined && requestData.useWane !== undefined
                                ? requestData.useWane
                                : this.useWane;
                            this.useCorelessBoard = requestData.corelessBoard !== undefined && requestData.corelessBoard.enabled !== undefined
                                ? requestData.corelessBoard.enabled
                                : this.useCorelessBoard;
                            this.corelessBoardThickness = requestData.corelessBoard !== undefined && requestData.corelessBoard.thickness !== undefined
                                ? requestData.corelessBoard.thickness
                                : this.corelessBoardThickness;
                            this.corelessBoardPrice = requestData.corelessBoard !== undefined && requestData.corelessBoard.price !== undefined
                                ? requestData.corelessBoard.price
                                : this.corelessBoardPrice;

                            this.boardsCentral = [];
                            await requestData.boards.central.forEach(board => {
                                let lenRange = "";
                                this.boardsCentral.push({
                                    id: board.id,
                                    length: lenRange
                                });
                            })

                            this.boardsSide = [];
                            await requestData.boards.side.forEach(board => {
                                let lenRange = "";
                                this.boardsSide.push({
                                    id: board.id,
                                    length: lenRange
                                });
                            })

                            this.getLumber(true);

                            this.logInfo.dTop = responseData.info !== undefined && responseData.info.diamTop !== undefined
                                ? responseData.info.diamTop
                                : 0;
                            this.logInfo.dBottom = responseData.info !== undefined && responseData.info.diamKomel !== undefined
                                ? parseInt(responseData.info.diamKomel)
                                : 0;
                            this.logInfo.length = responseData.info !== undefined && responseData.info.logLength !== undefined
                                ? responseData.info.logLength
                                : 0;
                            this.logInfo.taper = responseData.info !== undefined && responseData.info.taper !== undefined
                                ? responseData.info.taper.toFixed(1)
                                : this.taper;
                            this.logInfo.species = responseData.info !== undefined && responseData.info.species !== undefined
                                ? responseData.info.species
                                : "";
                            this.logInfo.volume = responseData.info !== undefined && responseData.info.logVolume !== undefined
                                ? responseData.info.logVolume.toFixed(5)
                                : 0;
                            this.logInfo.curvature = responseData.info !== undefined && responseData.info.curvature !== undefined
                                ? parseFloat(responseData.info.curvature.toFixed(3))
                                : 0;
                            this.logInfo.curvCenter = responseData.info !== undefined && responseData.info.curvatureCenter !== undefined
                                ? parseFloat(responseData.info.curvatureCenter.toFixed(3))
                                : 0;
                            this.logInfo.ellipseRatio = responseData.info !== undefined && responseData.info.ellipseRatio !== undefined
                                ? parseFloat(responseData.info.ellipseRatio.toFixed(2))
                                : 0;
                            this.logInfo.rotationAngle = responseData.info !== undefined && responseData.info.rotationAngle !== undefined
                                ? parseInt(responseData.info.rotationAngle)
                                : 0;

                            this.results = responseData.patternList; //JSON.parse(response.data.result.ResponseJSON).patternList;

                            this.results.forEach((result) => {
                                let totalVol   = 0;
                                let totalPrice = 0;

                                if (result.info.boards) {
                                    result.info.boards.forEach((board) => {
                                        totalVol   += board.volume; // * board.amount;
                                        totalPrice += board.price; // * board.amount;
                                    });

                                    totalPrice -= result.info.rawMaterials.price;
                                    totalPrice -= result.info.expenses.price;
                                    totalPrice += result.info.sawdust.price;
                                    totalPrice += result.info.woodChips.price;
                                }

                                result.totalVol   = totalVol;
                                result.totalPrice = totalPrice;
                            });

                            this.results.forEach((result) => {
                                result.maxWidth = result.pattern.items ? this.getMaxBoardWidth(result.pattern.items) : 0;
                                result.recalcLogInfo = {};
                            });

                            this.resByVol       = [...this.results];
                            this.resByPrice     = [...this.results];
                            this.resByCantWidth = [...this.results];

                            this.resByVol.sort((a, b) => {
                                return a.totalVol > b.totalVol ? -1 : 1;
                            });

                            this.resByPrice.sort((a, b) => {
                                return a.totalPrice > b.totalPrice ? -1 : 1;
                            });

                            this.resByCantWidth.sort((a, b) => {
                                return this.getMaxBoardWidth(a.pattern.items) > this.getMaxBoardWidth(b.pattern.items) ? -1 : 1;
                            });

                            this.showInfoTable(this.resByVol, 'volume', 0);
                            this.selectedGroup = this.resByVol;
                        }

                        this.loading.calculationResult = false;
                        this.updateUserSettings = true;
                    })
                    .catch(err => {
                        this.loading.calculationResult = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> getTaskResult: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (typeof err == "string") {
                            this.showMessageBox(this.$t("information"), this.$t(err));
                        } else if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("applicationError"));
                        }
                    });
            },

            /**
             * Возвращает истину если передаваемый параметр - пустой объект
             *
             * @param {object} obj Проверяемый объект
             */
            objectIsEmpty (obj) {
                return obj == null || (
                        obj // 👈 null and undefined check
                        && Object.keys(obj).length === 0
                        && Object.getPrototypeOf(obj) === Object.prototype
                    );
            },

            /**
             * Получение пользовательских настроек
             */
            getUserSettings () {
                if (this.updateUserSettings) {
                    if (!localStorage.getItem("boards_side_" + this.speciesId) || !localStorage.getItem("boards_central_" + this.speciesId)) {
                        if (this.speciesId !== 0) {
                            this.getLumber();
                        }
                    } else {
                        this.boardsSide    = JSON.parse(localStorage.getItem("boards_side_" + this.speciesId));
                        this.boardsCentral = JSON.parse(localStorage.getItem("boards_central_" + this.speciesId));

                        let elem = this;
                        if (this.useCentralAsSide) {
                            this.boardsCentral.forEach((board) => {
                                elem.boardsSide.push(board);
                            });
                        }

                        this.getLumber(true);
                    }
                }
            },

            /**
             * Загрузка списка длин
             */
            loadLengths () {
                this.axios.get(`${this.$config.apiURL}lengths/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lengthsInfo = response.data.lengths

                            this.lengths = [];
                            lengthsInfo.forEach((item) => {
                                //if (item.Visible) {
                                    this.lengths.push({
                                        id:     item.id,
                                        length: this.$num.dropZeros((item.Ln / 1000)) //+ " " + component.$t("m")
                                    });
                                //}
                            });
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.status == 403 && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " +this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData"));
                        }

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> loadLengths: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Преобразует информацию о доске в формат для передачи во внешнее приложение
             *
             * @param {object} item Информация о доске
             *
             * @returns {object}
             */
            parseBoardInfo(item) {
                let board = {
                    id: 0,
                    lengths: [],
                    price: 0,
                    tn: 0,
                    wn: 0,
                    ts: 0,
                    ws: 0
                };

                board.id    = item.id;
                board.price = item.price;
                board.expenses = item.expenses;
                board.tn    = parseInt(item.size.slice(0, item.size.indexOf("x") - 1));
                board.wn    = parseInt(item.size.slice(item.size.indexOf("x") + 1));
                board.ts    = parseFloat(item.sawSize.slice(0, item.sawSize.indexOf("x") - 1));
                board.ws    = parseFloat(item.sawSize.slice(item.sawSize.indexOf("x") + 1));
                item.length.split(",").forEach((num) => {
                    board.lengths.push(parseFloat(num));
                });

                return board
            },

            /**
             * Преобразует информацию об оборудовании в формат для передачи во внешнее приложение
             *
             * @param {object} item Информация об оборудовании
             *
             * @returns {object}
             */
            parseEquipmentInfo(item) {
                let result = {
                    name: "",
                    data: {}
                }

                result.name = item.name;

                for (let param in item.data) {
                    if (param == "type") continue;
                    result.data[param] = item.data[param].val;
                }

                return result;
            },

            /**
             * Сбрасывает данные к значениям по умолчанию
             */
            resetData () {
                this.results        = [];
                this.resByVol       = [];
                this.resByPrice     = [];
                this.resByCantWidth = [];
                this.selectedGroup  = [];
                this.calculatedData = [];
                this.logInfo = {
                    dBottom:    0,
                    dTop:       0,
                    length:     0,
                    species:    null,
                    volume:     0,
                    curvature:  0,
                    curvCenter: 0
                };
                this.pattern = {};
            },

            recalculatePattern () {
                const removeMeta = (obj) => {
                    if (obj.hasOwnProperty("meta")) {
                        delete obj.meta;
                    }

                    for (let item in obj) {
                        if (typeof obj[item] === "object") { obj[item] = removeMeta(obj[item]); }
                    }

                    return obj;
                };

                let task = {
                    speciesId: parseInt(this.speciesId),
                    lineId:    this.equipmentId, //this.equipmentProfiles[this.equipmentId],
                    line:      [],
                    boards: {
                        central: [], //this.boardsCentral,
                        side:    [], //this.boardsSide
                    },
                    log: {
                        dTop:            this.$refs.EditPatternDialog.dTop,
                        l:               parseFloat(this.$refs.EditPatternDialog.logLength),
                        falseCore:       this.falseCore,
                        taper:           parseFloat(this.$refs.EditPatternDialog.taper),
                        curvature:       parseFloat(this.$refs.EditPatternDialog.curvature),
                        curvatureCenter: this.curvatureCenter,
                        ellipseRatio:    parseFloat(this.$refs.EditPatternDialog.ellipseRatio),
                        rotationAngle:   this.$refs.EditPatternDialog.rotate,
                        volume:          parseFloat(this.$refs.EditPatternDialog.volume)
                    },
                    useWane: this.useWane,
                    pattern: removeMeta(this.$refs.EditPatternDialog.pattern)
                };

                this.boardsCentral.forEach((val) => {
                    task.boards.central.push(this.parseBoardInfo(val))
                });

                this.boardsSide.forEach((val) => {
                    task.boards.side.push(this.parseBoardInfo(val))
                });

                this.equipmentProfiles.forEach((profile) => {
                    if (profile.id == this.equipmentId) {
                        profile.data.forEach((val) => {
                            task.line.push(this.parseEquipmentInfo(val));
                        });
                    }
                });

                this.loading.calculationResult = true;

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}tasks/`,
                    data: {
                        type:     3,    // 1 - Оптимизация раскроя, 2 - Поиск оптимального диаметра, 3 - пересчёт постава
                        dataJSON: JSON.stringify(task)
                    },
                    withCredentials: true
                }).then(response => {
                    this.callExternalApp(response.data.task.id, 2);
                    this.loading.calculationResult = false;
                }).catch(err => {
                    this.loading.calculationResult = false;

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `Optimization.vue -> calculate: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {  window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("calculationError"));
                    }
                });
            },

            /**
             * Сохранение текущего постава в библиотеку
             *
             * @param {string} patternName Название постава
             */
            savePattern (patternName) {
                let pattern = this.$refs.PatternVue.getPattern();

                delete pattern.info;

                let jsonPattern = JSON.stringify(pattern);
                const searchLenRegExp = /"len":\d*.\d*,/g;
                const searchWaneRegExp = /"waneLen":\d*.\d*,/g;
                //this.$debug.log(jsonPattern.replace(searchRegExp,""));

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}patterns/`,
                    data: {
                        speciesId: this.speciesId,
                        species:   pattern.species,
                        name:      patternName,
                        Du:        parseInt(this.logInfo.dTop/10),
                        Dmin:      pattern.dmin,
                        Dmax:      pattern.dmax,
                        DLimitMin: pattern.dlimitmin,
                        DLimitMax: pattern.dlimitmax,
                        Visible:   true,
                        DataJSON:  jsonPattern.replace(searchLenRegExp,"").replace(searchWaneRegExp,"")
                    },
                    withCredentials: true
                }).then(() => {
                    this.dataSavedAlert = true;
                }).catch(err => {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `Optimization.vue -> savePattern: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSavePattern") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSavePattern") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSavePattern"));
                    }
                });

            },

            /**
             * Обработчик нажатия кнопки сохранения постава
             */
            savePatternClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.TextInputDialog.answer",
                    (val) => {
                        if (val) { this.savePattern(this.$refs.TextInputDialog.textInput); }
                    }
                );

                let curTimestamp = new Date();

                this.$refs.TextInputDialog.answer    = null;
                this.$refs.TextInputDialog.title     = this.$t("savePattern");
                this.$refs.TextInputDialog.hintText  = this.$t("patternName");
                this.$refs.TextInputDialog.textInput = `${this.$t("pattern")} - D${parseInt(this.logInfo.dTop/10)}, ${curTimestamp.toLocaleDateString()}`;
                this.$refs.TextInputDialog.dialog    = true;
            },

            /**
             * Обработчик нажатия кнопки сохранения расчета
             */
             saveCalculationClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге*/
                this.dialogWatcher = this.$watch(
                    "$refs.SaveCalculationDialog.saveData",
                    (val) => {
                        if (val) {
                            let savingTask = {
                                speciesId: parseInt(this.speciesId),
                                method:    this.optMethod,
                                equipmentId: parseInt(this.equipmentId),
                                line:      [], //this.equipmentProfiles[this.equipmentId],
                                boards: {
                                    central: [], //this.boardsCentral,
                                    side:    [], //this.boardsSide
                                },
                                logParamsBeforeOpti: {
                                    dTop:            this.dTop,
                                    l:               this.length,
                                    falseCore:       this.falseCore,
                                    taper:           parseFloat(this.taper),
                                    curvature:       parseFloat(this.curvature),
                                    curvatureCenter: this.curvatureCenter,
                                    ellipseRatio:    this.ellipseRatio,
                                    rotationAngle:   this.rotate,
                                    volume:          parseFloat(this.volume)
                                },
                                logParamsAfterOpti: this.logInfo,
                                useWane: this.useWane,
                                corelessBoard: {
                                    enabled:   this.useCorelessBoard,
                                    thickness: this.corelessBoardThickness,
                                    price:     this.corelessBoardPrice
                                },
                                calculationResults: []
                            };

                            this.boardsCentral.forEach((val) => {
                                savingTask.boards.central.push(this.parseBoardInfo(val))
                            });

                            this.boardsSide.forEach((val) => {
                                savingTask.boards.side.push(this.parseBoardInfo(val))
                            });

                            // this.equipmentProfiles.forEach((profile) => {
                            //     if (profile.id == this.equipmentId) {
                            //         profile.data.forEach((val) => {
                            //             savingTask.line.push(this.parseEquipmentInfo(val));
                            //         });
                            //     }
                            // });

                            if (this.optMethod == "price") {
                                this.resByPrice.forEach((res, index) => {
                                    if (this.$refs.SaveCalculationDialog.patternsAmount == 0) {
                                        savingTask.calculationResults.push(res);
                                    } else if (index < this.$refs.SaveCalculationDialog.patternsAmount) {
                                        savingTask.calculationResults.push(res);
                                    }
                                });
                            } else {
                                this.resByVol.forEach((res, index) => {
                                    if (this.$refs.SaveCalculationDialog.patternsAmount == 0) {
                                        savingTask.calculationResults.push(res);
                                    } else if (index < this.$refs.SaveCalculationDialog.patternsAmount) {
                                        savingTask.calculationResults.push(res);
                                    }
                                });
                            }

                            this.axios({
                                method: "post",
                                url: `${this.$config.apiURL}tasks/saved/`,
                                data: {
                                    SpeciesId:  parseInt(this.speciesId),
                                    ContractId: parseInt(this.$refs.SaveCalculationDialog.selectedContract),
                                    TaskId:     this.taskId,
                                    Name:       this.$refs.SaveCalculationDialog.name,
                                    Comment:    this.$refs.SaveCalculationDialog.comment,
                                    DataJSON:   JSON.stringify(savingTask)
                                },
                                withCredentials: true
                            }).then(() => {
                                this.dataSavedAlert = true;
                                //this.dataUpdated    = true;
                            }).catch(error => {
                                if (error.response && error.response.status == 401) {
                                    this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                    // Удаление наблюдателя если установлен
                                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                    // Отслеживание нажатия кнопки ok в диалоге
                                    this.dialogWatcher = this.$watch(
                                        "$refs.MessageBox.dialog",
                                        () => { window.location.reload(); }
                                    );
                                } else if (error.response && error.response.status == 402) {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateCalculation") + ". " + this.$t("subscriptionExpired"));

                                    // Удаление наблюдателя если установлен
                                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                    // Отслеживание нажатия кнопки ok в диалоге
                                    this.dialogWatcher = this.$watch(
                                        "$refs.MessageBox.dialog",
                                        () => { this.$emit("doLogout", true); }
                                    );
                                } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                    this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                } else if (error.response && error.response.status == 403) {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateCalculation") + ". " + this.$t("accessDenied"));
                                } else {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateCalculation"));
                                }
                            });
                        }
                    }
                );

                this.$refs.SaveCalculationDialog.resetForm();
                this.$refs.SaveCalculationDialog.saveData = false;
                this.$refs.SaveCalculationDialog.dialog    = true;
            },

            savedCalculationsClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге*/
                this.dialogWatcher = this.$watch(
                    "$refs.SavedCalculationsDialog.loadTask",
                    (val) => {
                        if (val) {
                            this.taskId = this.$refs.SavedCalculationsDialog.selectedRow.id;

                            this.loading.calculationResult = true;

                            this.axios.get(`${this.$config.apiURL}tasks/saved/${this.taskId}/`, { withCredentials: true })
                                .then( async response => {
                                    if (response.data.status == "success") {

                                        let dataJSON = JSON.parse(response.data.task.DataJSON);

                                        if (dataJSON == null) {
                                            throw "optimizerResponseIsNull";
                                        }

                                        this.calcTimestamp = new Date(response.data.task.createdAt).toLocaleDateString() + " " + new Date(response.data.task.createdAt).toLocaleTimeString();

                                        this.updateUserSettings = false;

                                        this.optMethod = dataJSON !== undefined && dataJSON.method !== undefined
                                            ? dataJSON.method
                                            : "vol";
                                        this.volume = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.volume !== undefined
                                            ? dataJSON.logParamsBeforeOpti.volume
                                            : this.volume;
                                        this.dTop = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.dTop !== undefined
                                            ? dataJSON.logParamsBeforeOpti.dTop
                                            : this.dTop;
                                        this.length = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.l !== undefined
                                            ? dataJSON.logParamsBeforeOpti.l
                                            : this.length;
                                        this.taper = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.taper !== undefined
                                            ? dataJSON.logParamsBeforeOpti.taper
                                            : this.taper;
                                        this.curvature = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.curvature !== undefined
                                            ? dataJSON.logParamsBeforeOpti.curvature
                                            : this.curvature;
                                        this.curvatureCenter = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.curvatureCenter !== undefined
                                            ? dataJSON.logParamsBeforeOpti.curvatureCenter
                                            : this.curvatureCenter;
                                        this.ellipseRatio = dataJSON.logParamsBeforeOpti !== undefined && dataJSON.logParamsBeforeOpti.ellipseRatio !== undefined
                                            ? dataJSON.logParamsBeforeOpti.ellipseRatio
                                            : this.ellipseRatio;
                                        this.speciesId = dataJSON !== undefined && dataJSON.speciesId !== undefined
                                            ? dataJSON.speciesId
                                            : this.speciesId;
                                        this.equipmentId = dataJSON !== undefined && dataJSON.lineId !== undefined
                                            ? dataJSON.lineId
                                            : this.equipmentId;
                                        this.useWane = dataJSON !== undefined && dataJSON.useWane !== undefined
                                            ? dataJSON.useWane
                                            : this.useWane;
                                        this.useCorelessBoard = dataJSON.corelessBoard !== undefined && dataJSON.corelessBoard.enabled !== undefined
                                            ? dataJSON.corelessBoard.enabled
                                            : this.useCorelessBoard;
                                        this.corelessBoardThickness = dataJSON.corelessBoard !== undefined && dataJSON.corelessBoard.thickness !== undefined
                                            ? dataJSON.corelessBoard.thickness
                                            : this.corelessBoardThickness;
                                        this.corelessBoardPrice = dataJSON.corelessBoard !== undefined && dataJSON.corelessBoard.price !== undefined
                                            ? dataJSON.corelessBoard.price
                                            : this.corelessBoardPrice;

                                        this.boardsCentral = [];
                                        await dataJSON.boards.central.forEach(board => {
                                            let lenRange = "";
                                            this.boardsCentral.push({
                                                id: board.id,
                                                length: lenRange
                                            });
                                        })

                                        this.boardsSide = [];
                                        await dataJSON.boards.side.forEach(board => {
                                            let lenRange = "";
                                            this.boardsSide.push({
                                                id: board.id,
                                                length: lenRange
                                            });
                                        })

                                        this.getLumber(true);

                                        this.logInfo.dTop = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.dTop !== undefined
                                            ? dataJSON.logParamsAfterOpti.dTop
                                            : 0;
                                        this.logInfo.dBottom = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.dBottom !== undefined
                                            ? parseInt(dataJSON.logParamsAfterOpti.dBottom)
                                            : 0;
                                        this.logInfo.length = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.length !== undefined
                                            ? dataJSON.logParamsAfterOpti.length
                                            : 0;
                                        this.logInfo.taper = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.taper !== undefined
                                            ? parseFloat(dataJSON.logParamsAfterOpti.taper).toFixed(1)
                                            : this.taper;
                                        this.logInfo.species = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.species !== undefined
                                            ? dataJSON.logParamsAfterOpti.species
                                            : "";
                                        this.logInfo.volume = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.volume !== undefined
                                            ? parseFloat(dataJSON.logParamsAfterOpti.volume).toFixed(5)
                                            : 0;
                                        this.logInfo.curvature = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.curvature !== undefined
                                            ? parseFloat(dataJSON.logParamsAfterOpti.curvature.toFixed(3))
                                            : 0;
                                        this.logInfo.curvCenter = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.curvCenter !== undefined
                                            ? parseFloat(dataJSON.logParamsAfterOpti.curvCenter.toFixed(3))
                                            : 0;
                                        this.logInfo.ellipseRatio = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.ellipseRatio !== undefined
                                            ? parseFloat(dataJSON.logParamsAfterOpti.ellipseRatio.toFixed(2))
                                            : 0;
                                        this.logInfo.rotationAngle = dataJSON.logParamsAfterOpti !== undefined && dataJSON.logParamsAfterOpti.rotationAngle !== undefined
                                            ? parseInt(dataJSON.logParamsAfterOpti.rotationAngle)
                                            : 0;

                                        this.results = dataJSON.calculationResults; //JSON.parse(response.data.result.ResponseJSON).patternList;

                                        this.resByVol       = [...this.results];
                                        this.resByPrice     = [...this.results];
                                        this.resByCantWidth = [...this.results];

                                        this.resByVol.sort((a, b) => {
                                            return a.totalVol > b.totalVol ? -1 : 1;
                                        });

                                        this.resByPrice.sort((a, b) => {
                                            return a.totalPrice > b.totalPrice ? -1 : 1;
                                        });

                                        this.resByCantWidth.sort((a, b) => {
                                            return this.getMaxBoardWidth(a.pattern.items) > this.getMaxBoardWidth(b.pattern.items) ? -1 : 1;
                                        });

                                        this.showInfoTable(this.resByVol, 'volume', 0);
                                        this.selectedGroup = this.resByVol;
                                    }

                                    this.loading.calculationResult = false;
                                    this.updateUserSettings = true;
                                })
                                .catch(err => {
                                    this.loading.calculationResult = false;

                                    this.axios({
                                        method: "post",
                                        url: `${this.$config.apiURL}syslog/`,
                                        data: {
                                            messageType: "error",
                                            messageText: `Optimization.vue -> getTaskResult: ${JSON.stringify(err)}`
                                        },
                                        withCredentials: true
                                    }).then(response => {
                                        if (response.data.status == "failure") {
                                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                                        }
                                    }).catch(error => {
                                        if (error.response && error.response.status == 402) {
                                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                        } else if (error.response && error.response.status == 403) {
                                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                                        }
                                    });

                                    if (typeof err == "string") {
                                        this.showMessageBox(this.$t("information"), this.$t(err));
                                    } else if (err.response && err.response.status == 401) {
                                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                        // Удаление наблюдателя если установлен
                                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                        // Отслеживание нажатия кнопки ok в диалоге
                                        this.dialogWatcher = this.$watch(
                                            "$refs.MessageBox.dialog",
                                            () => { window.location.reload(); }
                                        );
                                    } else if (err.response && err.response.status == 402) {
                                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                                        // Удаление наблюдателя если установлен
                                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                        // Отслеживание нажатия кнопки ok в диалоге
                                        this.dialogWatcher = this.$watch(
                                            "$refs.MessageBox.dialog",
                                            () => { this.$emit("doLogout", true); }
                                        );
                                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                    } else if (err.response && err.response.status == 403) {
                                        this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                                    } else {
                                        this.showMessageBox(this.$t("error"), this.$t("applicationError"));
                                    }
                                });
                        }
                    }
                );

                this.$refs.SavedCalculationsDialog.selectedRow = null;
                this.$refs.SavedCalculationsDialog.loadTask = false;
                this.$refs.SavedCalculationsDialog.dialog = true;
            },

            /**
             * Отображение информации об ошибке
             *
             * @param {object} responseData Полученные от оптимизатора данные
             */
            showError (responseData) {
                if (responseData.error) {
                    //let optimizer = this;
                    let line = responseData.line ? responseData.line : [];

                    switch (responseData.error.type) {
                        case "VolumeTableDataNotFound":
                        case "VolumeError":
                            this.$refs.CalcErrorDialog.message = "errors.volumeTableDataNotFound";
                            break;
                        case "NoSawDevices":
                            this.$refs.CalcErrorDialog.message = "errors.noSawDevices";
                            break;
                        case "NoOptimalPattern":
                            this.$refs.CalcErrorDialog.message = "errors.noOptimalPattern";
                            break;
                        case "EmptyPatterns":
                            this.$refs.CalcErrorDialog.message = "errors.emptyPatterns";
                            break;
                        case "ErrorMethod":
                            this.$refs.CalcErrorDialog.message = "errors.errorMethod";
                            break;
                        case "FbsDiamMaxLog":
                            this.$refs.CalcErrorDialog.message = "errors.fbsDiamMaxLog";
                    }

                    let hideLine = true;
                    let num = 0;
                    line.forEach((equipment) => {
                        equipment.alert = ++num == responseData.error.deviceNum;
                        hideLine = equipment.alert ? false : hideLine;

                        switch (equipment.name) {
                            case "circularSaw":
                                equipment.image = "img/equipment/circular.webp";
                                break;
                            case "edgeTrimmer":
                                equipment.image = "img/equipment/edge_trimmer.webp";
                                break;
                            case "fbs":
                                equipment.image = "img/equipment/fbs.webp";
                                break;
                            case "multiSaw":
                                equipment.image = "img/equipment/multisaw.webp";
                                break
                            case "profilingMachine":
                                equipment.image = "img/equipment/profiling.webp";
                                break;
                            case "rotateAndPositioningDev":
                                equipment.image = "img/equipment/turn.webp";
                                break;
                            case "scanner":
                                equipment.image = "img/equipment/scanner.webp";
                                break;
                            case "horizontalSaw":
                                equipment.image = "img/equipment/horizontalsaw.webp";
                        }
                    });

                    this.$refs.CalcErrorDialog.hideLine = hideLine;
                    this.$refs.CalcErrorDialog.line     = line;
                    this.$refs.CalcErrorDialog.dialog   = true;
                }
            },

            showEditPatternDlg () {
                let originalPattern = JSON.parse(JSON.stringify(this.pattern));

                const removeMeta = (obj, delLen) => {
                    if (obj.hasOwnProperty("meta")) {
                        delete obj.meta;
                    }

                    if (delLen && obj.hasOwnProperty("len")) {
                        delete obj.len;
                    }

                    for (let item in obj) {
                        if (typeof obj[item] === "object") { obj[item] = removeMeta(obj[item], delLen); }
                    }

                    return obj;
                };

                removeMeta(originalPattern, false);
                removeMeta(this.pattern, true);

                this.$refs.EditPatternDialog.pattern       = this.pattern;
                this.$refs.EditPatternDialog.boardsCentralFiltered = this.boardsCentral;
                this.$refs.EditPatternDialog.boardsSideFiltered    = this.boardsSide;
                this.$refs.EditPatternDialog.volume         = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.volume
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.volume;
                this.$refs.EditPatternDialog.taper         = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.taper
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.taper;
                this.$refs.EditPatternDialog.logLength     = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.length
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.len;
                this.$refs.EditPatternDialog.dTop      = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.dTop
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.dTop;
                this.$refs.EditPatternDialog.dBottom   = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.dBottom
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.dBottom;
                this.$refs.EditPatternDialog.curvature = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.curvature
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.curvature;
                this.$refs.EditPatternDialog.ellipseRatio = this.objectIsEmpty(this.selectedGroup[this.resIndex].recalcLogInfo)
                                                            ? this.logInfo.ellipseRatio
                                                            : this.selectedGroup[this.resIndex].recalcLogInfo.ellipseRatio;
                this.$refs.EditPatternDialog.rotate    = this.rotate;

                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                //Отслеживание изменение списка поставов
                this.dialogWatcher = this.$watch(
                    "$refs.EditPatternDialog.recalculate",
                    async (val) => {
                        if (val) {
                            await this.recalculatePattern();
                            this.$refs.PatternVue.updatePattern(this.pattern);
                        } else {
                            this.pattern = originalPattern;

                            if (this.resGroup == "cant") {
                                this.resByCantWidth[this.resIndex].pattern = originalPattern;
                            } else if (this.resGroup == "price") {
                                this.resByPrice[this.resIndex].pattern = originalPattern;
                            } else if (this.resGroup == "volume") {
                                this.resByVol[this.resIndex].pattern = originalPattern;
                            }
                        }
                    }
                );

                this.$refs.EditPatternDialog.recalculationForm = true;
                this.$refs.EditPatternDialog.dialog = true;
            },

            tasksHistoryClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.TasksHistoryDialog.id",
                    (val) => {
                        if (val) { this.getTaskResult(val); }
                    }
                );
                //Сбрасываем начальную позицию 3Д модели при смене расчёта
                this.$refs.ThreeDPatternView.cameraPosition.z = 0;

                this.$refs.TasksHistoryDialog.id       = null;
                this.$refs.TasksHistoryDialog.taskType = 1;
                this.$refs.TasksHistoryDialog.dialog   = true;
            },

            calcLogInfo () {
                if (this.logsAmount > 0 && !isNaN(this.logsAmount)) {
                    if (this.resGroup == "cant") {
                        this.showInfoTable(this.resByCantWidth, 'cant', this.resIndex);
                    } else if (this.resGroup == "price") {
                        this.showInfoTable(this.resByPrice, 'price', this.resIndex);
                    } else if (this.resGroup == "volume") {
                        this.showInfoTable(this.resByVol, 'volume', this.resIndex);
                    }
                }
            },

            /**
             * Отображерние сводной таблицы
             *
             * @param {array} group Группа результатов
             * @param {string} groupName Название группы
             * @param {number} index Индекс результата
             */
            showInfoTable (group, groupName, index) {
                if (group.length == 0) { return; }

                this.resGroup       = groupName;
                this.resIndex       = index;
                this.selectedGroup  = group;
                this.pattern        = group[index] !== undefined ? group[index].pattern : {};
                this.calculatedData = [];

                let totalQty        = 0;
                let totalVol        = 0;
                let totalSawVol     = 0;
                let totalPrice      = 0;
                let grandTotalPrice = 0;

                if (group[index] !== undefined && group[index].info.boards) {
                    group[index].info.boards.sort((a, b) => {
                        if (a.tn === b.tn) {
                            return a.wn - b.wn;
                        } else {
                            return a.tn - b.tn;
                        }
                    });

                    group[index].info.boards.forEach((item) => {
                        totalQty   += item.amount * this.logsAmount;
                        totalVol   += item.volume * this.logsAmount;
                        totalSawVol += item.sawVolume * this.logsAmount;
                        totalPrice += item.price * this.logsAmount;
                        this.calculatedData.push({
                            size:   `${item.tn + " x " + item.wn} (${item.ts + "x" + item.ws})`,
                            nomSize: item.tn + " x " + item.wn,
                            sawSize: (item.ts ? item.ts.toFixed(1) : "") + " x " + (item.ws ? item.ws.toFixed(1) : ""),
                            length: item.length.toFixed(1),
                            qty:    item.amount * this.logsAmount,
                            volume: `${(item.volume * this.logsAmount).toFixed(4)} (${(item.sawVolume * this.logsAmount).toFixed(4)})`,
                            vol:    (item.volume * this.logsAmount).toFixed(4),
                            price:  (item.price * this.logsAmount).toFixed(2),
                            percent: this.selectedGroup[index] == null || this.$obj.isEmpty(this.selectedGroup[index].recalcLogInfo)
                                ? this.logInfo.volume > 0
                                    ? `${(parseFloat(item.volume) / parseFloat(this.logInfo.volume) * 100).toFixed(2)} (${(parseFloat(item.sawVolume) / parseFloat(this.logInfo.volume) * 100).toFixed(2)})%` : null
                                : this.selectedGroup[index].recalcLogInfo.volume > 0
                                    ? `${(parseFloat(item.volume) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)} (${(parseFloat(item.sawVolume) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)})%` : null
                        });
                    });
                    grandTotalPrice = parseFloat(totalPrice.toFixed(2));
                }

                this.calculatedData.push({
                    size:   "",
                    length: "",
                    qty:    "(" + totalQty + ")",
                    volume: `${totalVol.toFixed(4)} (${totalSawVol.toFixed(4)})`,
                    price:  totalPrice.toFixed(2),
                    percent: this.selectedGroup[index] == null || this.$obj.isEmpty(this.selectedGroup[index].recalcLogInfo)
                        ? this.logInfo.volume > 0
                            ? `${(parseFloat(totalVol/this.logsAmount) / parseFloat(this.logInfo.volume) * 100).toFixed(2)} (${(parseFloat(totalSawVol/this.logsAmount) / parseFloat(this.logInfo.volume) * 100).toFixed(2)})%` : null
                        : this.selectedGroup[index].recalcLogInfo.volume > 0
                            ? `${(parseFloat(totalVol/this.logsAmount) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)} (${(parseFloat(totalSawVol/this.logsAmount) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)})%` : null
                });

                this.calculatedData.push({
                    size:   "",
                    length: "",
                    qty:    "",
                    volume: "",
                    price:  ""
                });

                this.calculatedData.push({
                    size:    "",
                    length:  "",
                    qty:     this.$t("sawdust"),
                    volume:  group[index] !== undefined && group[index].info.sawdust ? (group[index].info.sawdust.volume* this.logsAmount).toFixed(4) : 0,
                    price:   group[index] !== undefined && group[index].info.sawdust ? (group[index].info.sawdust.price* this.logsAmount).toFixed(2) : 0,
                    percent: this.selectedGroup[index] == null || this.$obj.isEmpty(this.selectedGroup[index].recalcLogInfo)
                        ? group[index] !== undefined && group[index].info.sawdust && this.logInfo.volume > 0
                            ? `${(parseFloat(group[index].info.sawdust.volume) / parseFloat(this.logInfo.volume) * 100).toFixed(2)}%` : null
                        : group[index] !== undefined && group[index].info.sawdust && this.selectedGroup[index].recalcLogInfo.volume > 0
                            ? `${(parseFloat(group[index].info.sawdust.volume) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)}%` : null
                });
                grandTotalPrice += group[index] !== undefined && group[index].info.sawdust ? parseFloat(group[index].info.sawdust.price* this.logsAmount) : 0;

                this.calculatedData.push({
                    size:    "",
                    length:  "",
                    qty:     this.$t("woodChips"),
                    volume:  group[index] !== undefined && group[index].info.woodChips ? (group[index].info.woodChips.volume* this.logsAmount).toFixed(4) : 0,
                    price:   group[index] !== undefined && group[index].info.woodChips ? (group[index].info.woodChips.price* this.logsAmount).toFixed(2) : 0,
                    percent: this.selectedGroup[index] == null || this.$obj.isEmpty(this.selectedGroup[index].recalcLogInfo)
                        ? group[index] !== undefined && group[index].info.woodChips && this.logInfo.volume > 0
                            ? `${(parseFloat(group[index].info.woodChips.volume) / parseFloat(this.logInfo.volume) * 100).toFixed(2)}%` : null
                        : group[index] !== undefined && group[index].info.woodChips && this.selectedGroup[index].recalcLogInfo.volume > 0
                            ? `${(parseFloat(group[index].info.woodChips.volume) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)}%` : null
                });
                grandTotalPrice += group[index].info.woodChips ? parseFloat(group[index].info.woodChips.price* this.logsAmount) : 0;

                if (this.$store.getters.settings.lumberShrinkageCalcMethod == "fromLogVolume") {
                    this.calculatedData.push({
                        size:    "",
                        length:  "",
                        qty:     this.$t("drying"),
                        volume:  group[index] !== undefined && group[index].info.sawVolume ? (group[index].info.sawVolume* this.logsAmount).toFixed(4) : 0,
                        price:   "-",
                        percent: this.selectedGroup[index] == null || this.$obj.isEmpty(this.selectedGroup[index].recalcLogInfo)
                            ? group[index] !== undefined && group[index].info.sawVolume && this.logInfo.volume > 0
                                ? `${(parseFloat(group[index].info.sawVolume) / parseFloat(this.logInfo.volume) * 100).toFixed(2)}%` : null
                            : group[index] !== undefined && group[index].info.sawVolume && this.selectedGroup[index].recalcLogInfo.volume > 0
                                ? `${(parseFloat(group[index].info.sawVolume) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2)}%` : null
                    });
                } else {
                    this.calculatedData.push({
                        size:    "",
                        length:  "",
                        qty:     this.$t("drying"),
                        volume:  group[index] !== undefined && group[index].info.sawVolume ? (group[index].info.sawVolume* this.logsAmount).toFixed(4) : 0,
                        price:   "-",
                        percent: this.selectedGroup[index] != null
                            ? `${(parseFloat(group[index].info.sawVolume) / parseFloat(totalSawVol) * 100).toFixed(2)}%` : null
                    });
                }

                this.calculatedData.push({
                    size:   "",
                    length: "",
                    qty:    this.$t("rawMaterials"),
                    volume: group[index] !== undefined && group[index].info.rawMaterials ? (group[index].info.rawMaterials.volume* this.logsAmount).toFixed(4) : 0,
                    price:  group[index] !== undefined && group[index].info.rawMaterials ? (group[index].info.rawMaterials.price* this.logsAmount).toFixed(2) : 0
                });
                grandTotalPrice -= group[index] !== undefined && group[index].info.rawMaterials ? parseFloat(group[index].info.rawMaterials.price* this.logsAmount) : 0;

                this.calculatedData.push({
                    size:   "",
                    length: "",
                    qty:    this.$t("expenses"),
                    volume: "", //group[index].info.expenses.volume.toFixed(5),
                    price:  group[index] !== undefined && group[index].info.expenses.price ? (group[index].info.expenses.price* this.logsAmount).toFixed(2) : 0
                });
                grandTotalPrice -= group[index] !== undefined && group[index].info.expenses.price ? parseFloat(group[index].info.expenses.price* this.logsAmount) : 0;

                // this.calculatedData.push({
                //     size:   "",
                //     length: "",
                //     qty:    "",
                //     volume: "",
                //     price:  ""
                // });

                this.calculatedData.push({
                    size:   "",
                    length: "",
                    qty:    this.$t("total"),
                    volume: "",
                    price:  grandTotalPrice.toFixed(2)
                });

                this.output     = group[index] !== undefined && group[index].info.output ? parseFloat(group[index].info.output.toFixed(2)) : 0;
                this.outputRaw  = this.selectedGroup[index] == null || this.$obj.isEmpty(this.selectedGroup[index].recalcLogInfo)
                    ? (parseFloat(totalSawVol/this.logsAmount) / parseFloat(this.logInfo.volume) * 100).toFixed(2)
                    : (parseFloat(totalSawVol/this.logsAmount) / parseFloat(this.selectedGroup[index].recalcLogInfo.volume) * 100).toFixed(2);
                this.totalPrice = (grandTotalPrice/this.logsAmount).toFixed(2);
            },

            /**
             * Отображение диалога настроек кривизны
             */
            showCurvatureDialog () {
                this.$refs.CurvatureDialog.apply           = false;
                this.$refs.CurvatureDialog.curvatureCenter = this.curvatureCenter;
                this.$refs.CurvatureDialog.sawAxis         = this.sawAxis;
                this.$refs.CurvatureDialog.dialog          = true;
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение диалога выбора сечений
             */
            async showSelectCutsDialog () {
                //this.$refs.SelectCutsDialog.resetForm();
                this.$refs.SelectCutsDialog.speciesId             = this.speciesId;
                this.$refs.SelectCutsDialog.selectedGroupId       = 0;
                this.$refs.SelectCutsDialog.centralBoardsSelected = this.boardsCentral;
                this.$refs.SelectCutsDialog.sideBoardsSelected    = this.boardsSide;
                this.$refs.SelectCutsDialog.dialog                = true;
            },
        }
    }
</script>

<style lang="sass" scoped>
    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 96px)

    .cutting-scheme
        p
            font-size: 12px
            text-indent: 8px
    .flex-card
        display: flex
        flex-direction: column
        .v-toolbar
            flex: 0

    .pattern
        /*width: 350px*/
        /*height: 350px*/
        &-container
            box-sizing: border-box
            border: 1 !important
            display: inline-block
            padding: 8px
            min-height: 350px
            /*width: 340px*/
            /*height: 340px*/
            z-index: 999
        &-thumb-container
            box-sizing: border-box
            border: 0 !important
            display: inline-block
            padding-bottom: 2px
            padding-top: 12px
            width: 115px
            height: 115px
            z-index: 999
            .pattern
                width: 115px
                height: 115px
        &-icon
            width: 25px
            height: 25px
        &-legend
            > .line-wrapper
                display: inline-block
                margin-right: 10px
                text-align: left
                > .line-marker
                    display: inline-block
                    position: relative
                    top: 2px
                    width: 25px
                    padding: 6px 5px 6px 5px
                    background: #fff
                    border-radius: 2px
                    > hr
                        border: none
                        color: #fff
                        background-color: #fff
                        height: 1px
                        &.dashed
                            border-top: 2px dashed #000
                        &.dotted
                            border-top: 2px dotted #000
                            margin: 0
                        &.solid
                            border-top: 2px solid #000


    .info-table
        td
            padding: 5px
            min-width: 120px

    .param-table
        padding-left: 16px
        padding-right: 16px
        td
            padding-right: 16px

    .transparent-bg
        background: transparent

    .thumb-info
        position: relative
        top: -120px
        .number
            position: absolute
            top: 1px
            left: 1px
        .data
            position: absolute
            top: 1px
            right: 1px

    .edit-mark
        text-align: right
        margin-top: -18px
        height: 18px
</style>
